import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import * as CookieService from './CookieService';
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
//const apiKey = "ys3SsGdUJ47rqqg0Q768YQ";
//const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`;

const resources = {
    en: {
        translation: {
            "Site language": "Site language",
            "Approvals": "Approvals",
            "Welcome": "Welcome to React and react-i18next",
            "WelcomeKey": "Welcome",
            "Number": "Number",
            "Back": "Back",
            "Sign in with ": "Sign in with ",
            "No record": "No record",
            "Non-priority": "Non-priority",
            "Business": "Business",
            "Unit": "Unit",
            "Delivery": "Delivery",
            "Need by Date": "Need by Date",
            "Name": "Name",
            "Requisition": "Requisition",
            "Price": "Price",
            "Decline": "Decline",
            "Total": "Total",
            "Created": "Created",
            "Waiting": "Waiting",
            "Pending Approver": "Pending Approver",
            "f": "Division",
            "Region": "Region",
            "Sub Region": "Sub Region",
            "Export to Excel": "Export to Excel",
            "Buy Checked Items": "Buy Checked Items",
            "Status": "Status",
            "Install ": "Install",
            "Filter": "Filter",
            "Apply": "Apply",
            "Preference": "Preference",
            "Select Report": "Select Report",
            "Zip Code": "Zip Code",
            "Model": "Model",
            "Store": "Store",
            "Please enter": "Please enter",
            "Enter valid WorkOrder number": "Enter valid WorkOrder number",
            "Make": "Make",
            "Pre_filter": "Pre-filter",
            "Itemaddedtocart_key": "Item has been added to cart",
            "SearchQuickItem_key": "Search by Quick Item Entry",
            "Required_key": "Required",
            "done_key": "done",
            "more_key": "more",
            "save_key": "Save",
            "reset_key": "Reset",
            "Attachment": "Attachment",
            "part number": "Part Number",
            "unitofmeasure_key": "Unit of Measure",
            "recommended": "Recommended",
            "Vendor": "Vendor",
            "orderedfor_key": "Ordered For",
            "orderenteredby_key": "Order Entered by",
            "Priority": "Priority",
            "workorder_key": "Work Order",
            "order_key": "Order",
            "Quick Item Entry": "Quick Item Entry",
            "Items have to be from the same supplier for pickup to be enabled": "Items have to be from the same supplier for pickup to be enabled",
            "Pickup": "Pickup",
            "Customer Notes": "Customer Notes",
            "Edit": "Edit",
            "Favorite": "Favorite",
            "Bill-to-Store": "Bill-to-Store",
            "Ship To": "Ship To",
            "Delivery Date": "Delivery Date",
            "Asset Tag ID": "Asset Tag ID",
            "Employee": "Employee",
            "Details": "Details",
            "Item": "Item",
            "Shopping Cart": "Shopping Cart",
            "Download": "Download",
            "Archive": "Archive",
            "Date": "Date",
            "Title": "Title",
            "Notification": "Notification",
            "Number of Records": "Number of Records",
            "Quantity": "Quantity",
            "Action": "Action",
            "Your": "Your",
            "Description": "Description",
            "Category": "Category",
            "ID": "ID",
            "Continue Shopping": "Continue Shopping",
            "Return to": "Return to",
            "New": "New",
            "In the absence of written agreement to the contrary between customer and SDI, all pricing contained in this catalog is subject to change by SDI at any time without notice.": "In the absence of written agreement to the contrary between customer and SDI, all pricing contained in this catalog is subject to change by SDI at any time without notice.",
            "Profile": "Profile",
            "Home": "Home",
            "Update": "Update",
            "Enable": "Enable",
            "Crib Identifier": "Crib Identifier",
            "Block Price Display": "Block Price Display",
            "Client": "Client",
            "Catalog": "Catalog",
            "Cancel": "Cancel",
            "Submit": "Submit",
            "Approval": "Approval",
            "Customer": "Customer",
            "Partial Received": "Partial Received",
            "Approve": "Approve",
            "Information": "Information",
            "Fully Received": "Fully Received",
            "Quote": "Quote",
            "Cancelled": "Cancelled",
            "Rejected": "Rejected",
            "Delivered": "Delivered",
            "Complete": "Complete",
            "Quote Approved": "Quote Approved",
            "set": "set",
            "Delete": "Delete",
            "order_total_requiring_approval ": "Order Total Requiring Approval",
            "budg_approval_by": "Budgetary Approval by",
            "Address": "Address",
            "f_name": "First Name",
            "type": "Type",
            "Phone": "Phone",
            "l_name": "Last Name",
            "Deselect": "Deselect",
            "user_group": "User Group",
            "Expand": "Expand",
            "Collapse": "Collapse",
            "Role": "Role",
            "Site": "Site",
            "dept": "Department",
            "User": "User",
            "change_pwd": "Change Password",
            "Add": "Add",
            "Zeus": "Zeus",
            "Mobility": "Mobility",
            "Preferences": "Preferences",
            "emails": "Emails",
            "Product": "Product",
            "my": "My",
            "Logout": "Logout",
            "term_of_purchase": "Term of Purchase",
            "answer_lab": "Answer Lab",
            "f_p": "Favorite Page",
            "Account": "Account",
            "Selection": "Selection",
            "select": "Collapse",
            "Clear": "Clear",
            "test_site": "",
            "inv_supplier": "INVENTORY SUPPLIERS",
            "will_call_supplier": "WILL-CALL SUPPLIERS",
            "Parts List": "Parts List",
            "Supplier": "Supplier",
            "Manufacturer": "Manufacturer",
            "Mode": "Mode",
            "r_a": "Requestor Approval",
            "Help": "Help",
            "Tech Hub": "Tech Hub",
            "order_status": "Order Status",
            "Non-Catalog Request": "Non-Catalog Request",
            "punch_out": "Punch Out",
            "Maintenance": "Maintenance",
            "Privileges": "Privileges",
            "Entry": "Entry",
            "Reason": "Reason",
            "Choose File": "Choose File",
            "Archived": "Archived",
            "Page": "Page",
            "page": "page",
            "Total Items": "Total Items",
            "Location": "Location",
            "Summary": "Summary",
            "Confirm": "Confirm",
            "Over Pick": "Over Pick",
            "Under Pick": "Under Pick",
            "Zero Pick": "Zero Pick",
            "Yes": "Yes",
            "No": "No",
            "Order": "Order",
            "Picking Items": "Picking Items",
            "Info": "Info",
            "Select a site": "Select a site",
            "Item ID": "Item ID",
            "Action Code": "Action Code",
            "Utilization Code": "Utilization Code",
            "Forecast Family": "Forecast Family",
            "Zero On Hand": "Zero On Hand",
            "Replenish Type": "Replenish Type",
            "Replenish": "Replenish",
            "Replenish Class": "Replenish Class",
            "In Business Unit": "In Business Unit",
            "Business Unit": "Business Unit",
            "Replenish Status": "Replenish Status",
            "Not On Order": "Not On Order",
            "Cost": "Cost",
            "Extended Cost": "Extended Cost",
            "Process Replen": "Process Replen",
            "Average On Hand": "Average On Hand",
            "Growth": "Growth",
            "Order Forecast Model": "Order Forecast Model",
            "12 Month Forecast": "12 Month Forecast",
            "Month's Usage": "Month's Usage",
            "Next Order Date": "Next Order Date",
            "Next Order Qty": "Next Order Qty",
            "Data Posponed": "Data Posponed",
            "Review": "Review",
            "Next Review Date": "Next Review Date",
            "Days On Hand": "Days On Hand",
            "Excess Units": "Excess Units",
            "Excess Dollars": "Excess Dollars",
            "Receiveing Cost": "Receiveing Cost",
            "Service Level": "Service Level",
            "Max Weeks": "Max Weeks",
            "Carrying Cost": "Carrying Cost",
            "Item Stock Type": "Item Stock Type",
            "Safety stock": "Safety stock",
            "Package Size": "Package Size",
            "Max Capacity": "Max Capacity",
            "Lead-Time": "Lead-Time",
            "Optimal Order QTY": "Optimal Order Quantity",
            "Current On Hand": "Current On Hand",
            "Open PO Qty": "Open PO Qty",
            "Reserved Qty": "Reserved Qty",
            "Min": "Min",
            "Open": "Open",
            "Suggested Min": "Suggested Min",
            "Backorder": "Backorder",
            "Max": "Max",
            "Suggested Max": "Suggested Max",
            "Default Putaway": "Default Putaway",
            "Date Added": "Date Added",
            "Critical Spare": "Critical Spare",
            "Supplier Part Number": "Supplier Part Number",
            "Last Issues Date": "Last Issues Date",
            "Client Stock Type": "Client Stock Type",
            "Inventory Days On Hand": "Inventory Days On Hand",
            "Item Has Been Updated Successfully": "Item Has Been Updated Successfully",
            "Ok": "Ok",
            "Mismatch": "Mismatch",
            "Cycle Count": "Cycle Counting",
            "Standard Leadtime": "Standard Leadtime",
            "Machine Number": "Machine Number",
            "Drawing": "Drawing",
            "Purchasing Dept Spec": "Purchasing Dept Spec",
            "Regrind": "Regrind",
            "First": "First",
            "Issue": "Issue",
            "Charge": "Charge",
            "Code": "Code",
            "Replenish": "Replenish",
            "Reorder Paint": "Reorder Paint",
            "Modifiers": "Modifiers",
            "Attributes": "Attributes",
            "Path": "Path",
            "Noun": "Noun",
            "Store Room": "Store Room",
            "No attributes avaliable": "No attributes avaliable",
            "Total Order Qty": "Total Order QTY",
            "Article Number": "Article Number",
            "No. of Pieces": "No. of Pieces",
            "Material": "Material",
            "Owned By": "Owned By",
            "Package": "Package",
            "Features": "Features",
            "Cycle Count Reconciliation": "Cycle Count Reconciliation",
            "Variance": "Variance",
            "Reconciliation Tag": "Reconciliation Tag",
            "Item Ready For Update": "Item Ready For Update",
            "Finalization": "Finalization",
            "Load Recon": "Load Recon",
            "Counting Event": "Counting Event",
            "Entered Item Count": "Entered Item Count",
            "Bin": "Bin",
            "Equipment Tag": "Equipment Tag",
            "Inspection Required": "Inspection Required",
            "Hazard": "Hazard",
            "Tracking": "Tracking",
            "Ship Via": "Ship Via",
            "In": "In",
            "Ship Date": "Ship Date",
            "Years": "Years",
            "Months": "Months",
            "Select Duration": "Select Duration",
            "Receive Items": "Receive Items",
            "Inventory Management System": "Inventory Management System",
            "Search containing value limit to date range entered above": "Search containing value limit to date range entered above",
            "Search containing value but limit to last 6 months": "Search containing value but limit to last 6 months",
            "Search exact value": "Search exact value",
            "Orders": "Orders",
            "Search by": "Search by",
            "date range is limited to 3 months": "date range is limited to 3 months",
            "To": "To",
            "From": "From",
            "Report": "Report",
            "Select Report (by Order date)": "Select Report (by Order date)",
            "Items": "Items",
            "Lookup": "Lookup",
            "Check": "Check",
            "WAREHOUSE": "WAREHOUSE",
            "Categories": "Categories",
            "No Search Result found": "No Search Result found",
            "Did you mean": "Did you mean",
            "You searched for": "You searched for",
            "Search Result": "Search Result",
            "Received": "Received",
            "Search": "Search",
            "supplier_callin": "Supplier Call-In",
            "Email Address": "Email Address",
            "Password": "Password",
            "Confirm Password": "Confirm Password",
            "Privilege": "Privilege ",
            "A la Carte": "A la Carte",
            "Program Tree View": "Program Tree View",
            "Program": "Program",
            "Freight Provider :": "Freight Provider :",
            "History": "History",
            "Buy again :": "Buy again :",
            "Expected": "Expected",
            "Last Updated On": "Last Updated On",
            "Pending": "Pending",
            "Counted": "Counted",
            "Indicates Inventory Order": "Indicates Inventory Order",
            "Stock Value Report": "Stock Value Report",
            "Select": "Select",
            "GO": "GO",
            "Show Bin Loc": "Show Bin Loc",
            "Include Quantity On Hand": "Include Quantity On Hand",
            "ItemKey": "Item",
            "Planner CD": "Planner CD",
            "On Hand": "On Hand",
            "Currency": "Currency",
            "Run": "Run",
            "Count": "Count",
            "Avail": "Avail",
            "Crib": "Crib",
            "Aisle": "Aisle",
            "Row": "Row",
            "Shelf": "Shelf",
            "Reserv": "Reserv",
            "Actual": "Actual",
            "See not updated items": "See not updated items",
            "Change": "Change",
            "Add": "Add",
            "Track": "Track",
            "Current": "Current",
            "Added On": "Added On",
            "Other": "Other",
            "Approved": "Approved",
            "Waiting Approval Chain": "Waiting Approval Chain",
            "No Records found": "No Records found",
            "All": "All",
            "AllKey": "All",
            "Image": "Image",
            "Waiting Order Approval": "Waiting Order Approval",
            "Advanced": "Advanced",
            "Stock": "Stock",
            "UnDelete": "UnDelete",
            "Line": "Line",
            "Do you want to remove this item?": "Do you want to remove this item?",
            "Favorites": "Favorites",
            "Show": "Show",
            "Start": "Start",
            "End": "End",
            "Search Criteria": "Search Criteria",
            "Contains": "Contains",
            "Any": "Any",
            "Search": "Search",
            "Remaining": "Remaining",
            "Returned": "Returned",
            "Reason": "Reason",
            "Short": "Short",
            "Ship From": "Ship From",
            "Serial": "Serial",
            "Total Dollars": "Total Dollars",
            "Signature": "Signature",
            "Exceeded Budget": "Exceeded Budget",
            "Stock Issues Report": "Stock Issues Report",
            "Header": "Header",
            "Due": "Due",
            "Request by": "Request by",
            "Reject": "Reject",
            "Purchase": "Purchase",
            "Enter NONE If Asset ID Not Available": "Enter NONE If Asset ID Not Available",
            "Notes": "Notes",
            "Inventory": "Inventory",
            "Get Data": "Get Data",
            "Days": "Days",
            "Exclude Non - Variance": "Exclude Non - Variance",
            "Analysis": "Analysis",
            "Enable MultiSite Access": "Enable MultiSite Access",
            "User Type": "User Type",
            "Product Display Type": "Product Display Type",
            "Pickup From Local Supplier": "Pickup From Local Supplier",
            "Back to Home": "Back to Home",
            "There is no vendors available": "There is no vendors available",
            "No Vendor available": "No Vendor available",
            "Return": "Return",
            "PunchOut is not currently available for this Vendor.": "PunchOut is not currently available for this Vendor.",
            "A message was sent notifying site administrator of this problem.": "A message was sent notifying site administrator of this problem.",
            "We apologize for this inconvenience.": "We apologize for this inconvenience.",
            "Click on vendor's logo below to start browsing their catalog.": "Click on vendor's logo below to start browsing their catalog.",
            "Error": "Error",
            "Partner Vendor": "Partner Vendor",
            "Non-Catalog Orders require an additional process and you will be notified via email when your quote is available.At which point you will need to come back to this catalog to approve for final procession.": "Non-Catalog Orders require an additional process and you will be notified via email when your quote is available.At which point you will need to come back to this catalog to approve for final procession.",
            "Check Catalog": "Check Catalog",
            "Cheaper Option": "Cheaper Option",
            "Part": "Part",
            "No, thanks.": "No, thanks.",
            "Cheaper Item": "Cheaper Item",
            "Add To Cart": "Add To Cart",
            "Item you choose": "Item you choose",
            "Proceed with this item": "Proceed with this item",
            "Enter valid WO number": "Enter valid WO number",
            "contact sdi customer care": "contact sdi customer care",
            "Call us": "Call us",
            "All rights reserved.": "All rights reserved.",
            "Not": "Not",
            "You don't have Permission to": "You don't have Permission to",
            "Access this page": "Access this page",
            "Bin Label Printing": "Bin Label Printing",
            "Area": "Area",
            "OR": "OR",
            "Default": "Default",
            "Request Forgotten Password": "Request Forgotten Password",
            "Reset Password": "Reset Password",
            "Password will be reset and sent to the email address that was set up in the Login profile for the Login ID entered above.": "Password will be reset and sent to the email address that was set up in the Login profile for the Login ID entered above.",
            "Back To Login": "Back To Login",
            "Log in to your account": "Log in to your account",
            "Login": "Login",
            "Forgot Password": "Forgot Password",
            "Requested": "Requested",
            "Print": "Print",
            "Quantity On Hand": "Quantity On Hand",
            "Quick Confirm": "Quick Confirm",
            "Session Timeout": "Session Timeout",
            "Go to login": "Go to login",
            "Online Catalog Load": "Online Catalog Load",
            "Loading ...Please Wait": "Loading ...Please Wait",
            "Site Under Contruction": "Site Under Contruction",
            "Will be Back Soon!": "Will be Back Soon!",
            "Place Order": "Place Order",
            "Rush Order": "Rush Order",
            "Product Replenishment": "Product Replenishment",
            "Items currently in Cart": "Items currently in Cart",
            "Count Event": "Count Event",
            "Before": "Before",
            "After": "After",
            "Standard": "Standard",
            "Dollars": "Dollars",
            "Edit Favorites": "Edit Favorites",
            "Add New Favorites": "Add New Favorites",
            "Do you want to remove this order ?": "Do you want to remove this order ?",
            "Related site data not available at this time.": "Related site data not available at this time.",
            "Net Received": "Net Received",
            "Transaction": "Transaction",
            "Operator Entered By": "Operator Entered By",
            "Receiver": "Receiver",
            "Extended Client Description": "Extended Client Description",
            "Contact Us": "Contact Us",
            "Main Menu": "Main Menu",
            "Receiving": "Receiving",
            "Picking": "Picking",
            "Sorry, we couldn’t find any search result": "Sorry, we couldn’t find any search result",
            "Event": "Event",
            "Warning": "Warning",
            "Not all items flagged for update. Contine?": "Not all items flagged for update. Contine?",
            "Forecast": "Forecast",
            "Update Item": "Update Item",
            "Replenish Type": "Replenish Type",
            "Reason for Decline": "Reason for Decline",
            "Comments": "Comments",
            "Advanced Filter": "Advanced Filter",
            "Do you want to archieve this notification ?": "Do you want to archieve this notification ?",
            "Add Attachment": "Add Attachment",
            "Select file to attach": "Select file to attach",
            "Would you like to use line numbers by increments of 10?": "Would you like to use line numbers by increments of 10?",
            "Do you want to save this as a favorite order ?": "Do you want to save this as a favorite order ?",
            "Attach": "Attach",
            "Are you sure you want to cancel your order?": "Are you sure you want to cancel your order?",
            "These Items are not avialable.Please remove these items": "These Items are not avialable.Please remove these items",
            "Remove these items": "Remove these items",
            "Apply Change": "Apply Change",
            "Invoice": "Invoice",
            "Packing Slips": "Packing Slips",
            "No records to display": "No records to display",
            "Driver": "Driver",
            "Truck": "Truck",
            "Ordered By": "Ordered By",
            "Ship Container": "Ship Container",
            "Fragile Item Signature": "Fragile Item Signature",
            "Shipping": "Shipping",
            "Trade": "Trade",
            "Stop ID": "Stop ID",
            "Trucking / Delivery From": "Trucking / Delivery From",
            "Load ID": "Load ID",
            "The Cycle Count Accuracy for the time period": "The Cycle Count Accuracy for the time period",
            "The Absolute  Accuracy for the time period": "The Absolute Accuracy for the time period",
            "With a Total Dollar Difference of ": "With a Total Dollar Difference of ",
            "is": " is ",
            "Stock Issue Report": "Stock Issue Report",
            "Cycle Count Analysis": "Cycle Count Analysis",
            "Favorite Orders": "Favorite Orders",
            "UserNotifications": "UserNotifications",
            "RFQ Entry": "RFQ Entry",
            "Shop Redirect": "Shop Redirect",
            "Need Approve": "Need Approve",
            "Need Quote": "Need Quote",
            "Approve Quote": "Approve Quote",
            "User Profile": "User Profile",
            "Item Detail": "Item Detail",
            "Search Results": "Search Results",
            "Order Status": "Order status",
            "Supplier Call-In": "Supplier Call-In",
            "Receive": "Receive",
            "CycleCount": "CycleCount",
            "Recon": "Recon",
            "Replen Review": "Replen Review",
            "Labels by Location": "Labels by Location",
            "Order Status Report": "Order Status Report",
            "Reports": "Reports",
            "Edit Vendor Information": "Edit Vendor Information",
            "Edit User Information": "Edit User Information",
            "Edit Mexico Information": "Edit Mexico Information",
            "Activate/Inactivate Users": "Activate/Inactivate Users",
            "Replenish Review": "Replenish Review",
            "Replenish review": "Replenish review",
            "SDiMS Online": "SDiMS Online",
            "Approve Orders": "Approve Orders",
            "Requestor Approval": "Requestor Approval",
            "Favorite Item": "Favorite Item",
            "Reference Site": "Reference Site",
            "Tech Reference": "Tech Reference",
            "Door - DH Pace": "Door - DH Pace",
            "Lift Truck - Coats Garage": "Lift Truck - Coats Garage",
            "Lift Truck - Wiese": "Lift Truck - Wiese",
            "Lift Truck - HGM Liftparts": "Lift Truck - HGM Liftparts",
            "Last 7 Days": "Last 7 Days",
            "Last 15 Days": "Last 15 Days",
            "Last 30 Days": "Last 30 Days",
            "Last Month": "Last Month",
            "This Month": "This Month",
            "Select ReportKey": "Select Report",
            "Too Expensive (Need Cheaper Quote)": "Too Expensive (Need Cheaper Quote)",
            "Wrong Quantities": "Wrong Quantities",
            "No Longer Needed": "No Longer Needed",
            "Wrong Ship To Store": "Wrong Ship To Store",
            "Wrong Item(s)": "Wrong Item(s)",
            "Expand All": "Expand All",
            "Collapse All": "Collapse All",
            "Quick Item Entry": "Quick Item Entry",
            "Items from different Inventory Business Units cannot be added to same cart": "Items from different Inventory Business Units cannot be added to same cart",
            "Do you want to clean the cart?": "Do you want to clean the cart?",
            "SDI MRO for a more": "SDI MRO for a more ",
            "connected ": "connected ",
            " enterprise ": " enterprise ",
            "Speed to Execution": "Speed to Execution",
            "Simplify": "Simplify",
            "Commitment": "Commitment",
            "Perseverance": "Perseverance",
            "Courage": "Courage",
            "Solution-Oriented": "Solution-Oriented",
            "Check Order Status": "Check Order Status",
            "Favorite Item Maintanance": "Favorite Item Maintanance",
            "Non Catalog Request": "Non Catalog Request",
            "UserProfile": "UserProfile",
            "Non-Catalog Request Entry": "Non-Catalog Request Entry",
            "SDI Stock Issues Report": "SDI Stock Issues Report",
            "Product Replen": "Product Replen",
            "Receive Items": "Receive Items",
            "Picking Items": "Picking Items",
            " Non-Catalog Orders require an additional process and you will be notified via email when your quote is available. At which point you will need to come back to this catalog to approve for final procession.": " Non-Catalog Orders require an additional process and you will be notified via email when your quote is available. At which point you will need to come back to this catalog to approve for final procession.",
            "Catalog Search": "Catalog Search",
            "My Account": "My Account",
            "Return to Shopping Cart": "Return to Shopping Cart",
            "If the data provided is correct, you will receive an email with password reset instructions": "If the data provided is correct, you will receive an email with password reset instructions",
            "Item Maintenance": "Item Maintenance",
            "Enter": "Enter",
            "Utilization type": "Utilization type",
            "Note - all request for all item description modifications will be forwarded to the SDI  Catalog Department for review": "Note - all request for all item description modifications will be forwarded to the SDI  Catalog Department for review",
            "Note - all text that is entered below will be  printed on the SDI PO to the supplier": "Note - all text that is entered below will be  printed on the SDI PO to the supplier",
            "Min Qty on Hand": "Min Qty on Hand",
            "Max Quantity": "Max Quantity",
            "Modifier": "Modifier",
            "* Employee ID": "* Employee ID",
            "* Ship To": "* Ship To",
            "Is This Priority?": "Is This Priority?",
            "Tax Exempt": "Tax Exempt",
            "More Details": "More Details",
            "  Remove": "  Remove",
            "Available": "Available",
            "Attribute": "Attribute",
            "items in": "items in",
            "Utilization_Code": "Utilization Code",
            "Signed By": "Signed By",
            "Suggested Supplier :": "Suggested Supplier :",
            "Supplier :": "Supplier :",
            "Catalog Item Details": "Catalog Item Details",
            "Non Catalog Item Details": "Non Catalog Item Details",
            "Manufacture": "Manufacture",
            "Show Extended Description": "Show Extended Description",
            "Catalog Details": "Catalog Details",
            "Non Catalog Details": "Non Catalog Details",
            "PO Header Status:": "PO Header Status:",
            "Close": "Close",
            "Supplier Name": "Supplier Name",
            "Supplier Part#": "Supplier part#",
            "Zeus ID": "Zeus ID",
            "Select All": "Select All",
            "View My Selection": "View My Selection",
            "Tech Vault": "Tech Vault",
            "All": "All",
            "Notification ID": "Notification ID",
            "Type": "Type",
            "Title": "Title",
            "Archive All": "Archive All",
            "Archive Notification": "Archive Notification",
            "Archived Notification": "Archived Notification",
            "Profile Update": "Profile Update",
            "User ID": "User ID",
            "Search User": "Search user",
            "User details": "User details",
            "User privileges": "User privileges",
            "Program Tree View": "Program Tree View",
            "Privilege type": "Privilege type",
            "Alternate Requestor Approval": "Alternate Requestor Approval",
            "Alternate Requestor Approval by": "Alternate Requestor Approval by",
            "Remove": "Remove",
            "Order Status Emails": " Order Status Emails",
            "Waiting Approval Chain": "Waiting Approval Chain",
            "Waiting Customer Approval": "Waiting Customer Approval",
            "Requestor Approval": "Requestor Approval",
            "Customer Information": "Customer Information",
            "Vendor Information": "Vendor Information",
            "Quote Approved": "Quote Approved",
            "Quote Rejected": "Quote Rejected",
            "RFQ Approved": "RFQ Approved",
            "RFQ Complete": "RFQ Complete",
            "Fully Received": "Fully Received",
            "Partial Received": "Partial Received",
            "Default Ship To": "Default Ship To",
            "Home store": "Home store",
            "Crib Identifier": "Crib Identifier",
            "Enable Zeus": "Enable Zeus",
            "Disable Zeus": "Disable Zeus",
            "User information has been modified and saved successfully.": "User information has been modified and saved successfully.",
            "Error - password has already been used": "Error - password has already been used",
            "User ID already exists": "User ID already exists",
            "Invalid User ID": "Invalid User ID",
            "Technical issue": "Technical issue",
            "Equipment": "Equipment",
            "WO#_History": "WO# History",
            "Sub_category": "Sub_category",
            "Filter records": "Filter records",
            "Please select any fields to view the equipments": "Please select any fields to view the equipments",
            "Please enter a WO# to continue": "Please enter a WO# to continue",
            "Adding an item will remove the current items in your shopping cart. Do you want to proceed with this change?": "Adding an item will remove the current items in your shopping cart. Do you want to proceed with this change?",
            "Confirmation": "Confirmation",
            "Item successfully added to cart": "Item successfully added to cart",
            "Punchout Catalog": "Punchout Catalog",
            "Enter Login Id": "Enter login ID",
            "Enter Email Address": "Enter email address",
            "Enter Old Password": "Enter old password",
            "Enter New Password": "Enter new password",
            "Enter Confirm Password": "Enter confirm password",
            "Please enter your zeus ID and password": "Please enter your zeus ID and password",
            "Please enter zeus ID": "Please enter zeus ID",
            "Please enter a password":"Please enter a password",
            "Old Password is required": "Old password is required",
            "New Password is required": "New password is required",
            "Confirm Password is required": "Confirm password is required",
            "Password doesn't match": "Password doesn't match",
            "Warning!\nYou do not have permission to access the application": "Warning!\nYou do not have permission to access the application",
            "Please enter required fields": "Please enter required fields",
            "If the data provided is correct, you will receive an email with password reset instructions": "If the data provided is correct, you will receive an email with password reset instructions",
            "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character.Max length for password is 128 characters.": "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character. Max length for password is 128 characters.",
            "Speed to Execution": "Speed to Execution",
            "Agility": "Agility",
            "One SDI": "One SDI",
            "Operation Excellence": "Operation Excellence",
            "Courage": "Courage",
            "Invalid ID/password": "Invalid ID/password",
            "Zeus ID": "Zeus ID",
            "Manufacturer part # ": "Manufacturer part # ",
            "Manufacturer Part #": "Manufacturer Part # ",
            "Manufacturer name": "Manufacturer name",
            "Recommended supplier": "Recommended supplier",
            "Supplier part #": "Supplier part #",
            "Supplier Part #": "Supplier Part #",
            "Quantity": "Quantity",
            "Unit of measure": "Unit of measure",
            "Please enter manufacturer part #": "Please enter manufacturer part #",
            "Please enter manufacturer name": "Please enter manufacturer name",
            "Please enter quantity": "Please enter quantity",
            "Enter manufacturer part #": "Enter manufacturer part #",
            "Enter manufacturer name": "Enter manufacturer name",
            "Enter recommended supplier": "Enter recommended supplier",
            "Enter supplier part #": "Enter supplier part #",
            "Enter quantity": "Enter quantity",
            "Attachment ": "Attachment ",
            "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names.": "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names.",
            "Description": "Description",
            "Enter Description": "Enter description",
            "Please enter description": "Please enter description",
            "Order information": "Order information",
            "Work order #": "Work order #",
            "Enter work order #": "Enter work order #",
            " WO# History": " WO# History",
            "Enter work order number": "Enter work order number",
            "Please select Ship to ": "Please select ship to ",
            "Enter Valid Work Order #": "Enter valid work order #",
            "The default Ship-To's Country Code does not match the Work Order Store Country Code.": "The default ship-to's country code does not match the work order store country code.",
            "Order notes": "Order notes",
            "Enter order notes": "Enter order notes",
            "Priority ": "Priority ",
            "Item details": "Item details",
            "Cancel order": "Cancel order",
            "Submit Order": "Submit Order",
            "Order submitted for sourcing": "Order submitted for sourcing",
            "Successfully added to  cart": "Successfully added to cart",
            "Technical Issue -- Contact SDI": "Technical Issue -- Contact SDI",
            "Insufficient privilege to view non-catalog request": "Insufficient privilege to view non-catalog request",
            "You can choose only the Image and PDF files!!": "You can choose only the image and PDF files!!",
            "Selected file is already attached, please try again": "Selected file is already attached, please try again",
            "Please use different work order # for this panel.": "Please use different work order # for this panel.",
            "Is this priority?": "Is this priority?",
            "Browse": "Browse",
            "Please enter a valid Quantity": "Please enter a valid quantity",
            " Upload": " Upload",
            "Save": "Save",
            "Ship to": "Ship to",
            "Technical issue please contact SDI help desk": "Technical issue please contact SDI help desk",
            "Please select the Shipment Method": "Please select the shipment method",
            "Previously Purchased Items": "Previously purchased items",
            "Suggestions": "Suggestions",
            "Please enter work order number": "Please enter work order number",
            "Search results will be based on your selection": "Search results will be based on your selection",
            "Manage Forms": "Manage Forms",
            "Ordering": "Ordering",
            "Sourced Non-Catalog Entry": "Sourced Non-Catalog Entry",
            "Source non-catalog entry": "Source non-catalog entry",
            "Procurement": "Procurement",
            "Email": "Email",
            "Interactive Diagrams": "Interactive Diagrams",
            "Walk-In": "Walk-In",
            "Reference Site Maintenance": "Reference Site Maintenance",
            "FedEx Shipping": "FedEx Shipping",
            "Cycle Counting": "Cycle Counting",
            "Field Inventory Workbench": "Field Inventory Workbench",
            "Release Notes Maintenance": "Release Notes Maintenance",
            "Fulfillment": "Fulfillment",
            "Item Master": "Item Master",
            "Maintain Inventory": "Maintain Inventory",
            "SDIMS Online": "SDIMS Online",
            "Print Container Bar Code Labels": "Print Container Bar Code Labels",
            "Stock Issue": "Stock Issue",
            "Return to Inventory": "Return to Inventory",
            "Picking Assign To": "Picking Assign To",
            "Reprint Packing": "Reprint Packing",
            "Default Putaway Location": "Default Putaway Location",
            "Add Stock Items": "Add Stock Items",
            "Bin-to - Bin Transfer": "Bin-to - Bin Transfer",
            "Manual Stock Adjustment": "Manual Stock Adjustment",
            "Item Holds": "Item Holds",
            "Material Storage Locations": "Material Storage Locations",
            "Express Putaway": "Express Putaway",
            "Mobile Inventory Management System": "Mobile Inventory Management System",
            "Load Stage and Putaway": "Load Stage and Putaway",
            "Shipments": "Shipments",
            "Expediting": "Expediting",
            "Open POs": "Open POs",
            "Transaction Report": "Transaction Report",
            "SDI ASN Entry": "SDI ASN Entry",
            "PO Workbench": "PO Workbench",
            "Tech hub": "Tech hub",
            "Tech vault": "Tech vault",
            "Reference Site": "Reference Site",
            "You searched for": "You searched for",
            "Search Result": "Search result",
            "Enter WO#": "Enter WO#",
            "Matching part details": "Matching part details",
            "UOM": "UOM",
            "No records found": "No records found",
            "Warehouse": "Warehouse",
            "Truck Stock": "Truck Stock",
            "Shipment Method": "Shipment method",
            "Equivalent Parts": "Equivalent Parts",
            "Supplier part number": "Supplier part number",
            "MFG name": "MFG name",
            "MFG part number": "MFG part number",
            "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?": "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?",
            "Entered quantity is greater than the available quantity ": "Entered quantity is greater than the available quantity ",
            "Quantity Entered Is Below The Minimum Order Quantity": "Quantity entered is below the minimum order quantity",
            "Entered Quantity Does Not Match the Minimum Order Quantity Sequence": "Entered quantity does not match the minimum order quantity sequence",
            " Item is already added in the cart ": " Item is already added in the cart ",
            "KENSTAN-KEY is already added to cart, only one key allow for one cart. Please go to cart to increase quantity": "KENSTAN-KEY is already added to cart, only one key allow for one cart. Please go to cart to increase quantity",
            "This item is already in the cart and has reached the maximum number of 10 forms": "This item is already in the cart and has reached the maximum number of 10 forms",
            " is not added to cart due to technical issue. Contact SDI customer care.": " is not added to cart due to technical issue. Contact SDI customer care.",
            "Item successfully added to cart and added item applies core charges": "Item successfully added to cart and added item applies core charges",
            "Item cannot be added to cart due to technical issue.Contact SDI customer care.": " Item cannot be added to cart due to technical issue. Contact SDI customer care.",
            "Favorite item removed sucessfully": "Favorite item removed sucessfully",
            "You cannot decrement Below the minimum order quantity": "You cannot decrement Below the minimum order quantity",
            "Favorite item inserted successfully": "Favorite item inserted successfully",
            "Quantity Cannot Be Zero": "Quantity cannot be zero",
            "Quantity Should Not Be Empty": "Quantity should not be empty",
            "This Kensktan lock is already in the cart. Please go to cart to increase quantity": "This Kensktan lock is already in the cart. Please go to cart to increase quantity",
            "This Enersys Item is already added in the cart": "This Enersys Item is already added in the cart",
            "This Door Item is already added in the cart. Please go to cart to increase quantity": "This Door ttem is already added in the cart. Please go to cart to increase quantity",
            "Technical Issue Try again": "Technical issue try again",
            "Long description": "Long description",
            "Short description": "Short description",
            "Rating": "Rating",
            "Supplier": "Supplier",
            "Minimum Order Quantity": "Minimum order quantity",
            "Delivers By": "Delivers by",
            "Total Order Quantity": "Total order quantity",
            "Things to be noted while uploading an Image": "Things to be noted while uploading an Image",
            "1.Size should be large": "1.Size should be large",
            "2.Background must be black/white": "2.Background must be black/white",
            "3.Should not contains any watermarks": "3.Should not contains any watermarks",
            "4.Should contains only one part per image": "4.Should contains only one part per image",
            "5.Should not be a hand held picture": "5.Should not be a hand held picture",
            "User also bought": "User also bought",
            "Add Review": "Add review",
            "Inventory": "Inventory",
            "Attributes": "Attributes",
            "Also Fits": "Also fits",
            "Links": "Links",
            "Image Uploaded Successfully!": "Image uploaded successfully!",
            "Upload failed!": "Upload failed!",
            "Confirmation": "Confirmation",
            "No reviews yet": "No reviews yet",
            "Replacement batteries are not currently available through Zeus, please consult with your manager or vendor management office (VMO) or order a replacement through service channel via home office realty procurement solutions (RPS) - sorry for any inconvenience this may cause": "Replacement batteries are not currently available through Zeus, please consult with your manager or vendor management office (VMO) or order a replacement through service channel via home office realty procurement solutions (RPS) - sorry for any inconvenience this may cause",
            "Package Quantity": "Package quantity",
            "Updated to Walmart Preferred Item(s)": "Updated to walmart preferred item(s)",
            "Ship within": "Ship within",
            "Add To Cart": "Add to cart",
            "Thank you for your response": "Thank you for your response",
            "Error in inserting the rating. Please contact SDI": "Error in inserting the rating. Please contact SDI",
            "PO Workbench": "PO Workbench",
            "Select or enter at least one of the following ( ) fields: Ship to locationC-O-M-M-A PO numberC-O-M-M-A Vendor nameC-O-M-M-A Install store and Work order to filter down your records": "Select or enter at least one of the following ( ) fields: Ship to locationC-O-M-M-A PO numberC-O-M-M-A Vendor nameC-O-M-M-A Install store and Work order to filter down your records",
            "Enter ship to location": "Enter ship to location",
            "Enter PO number": "Enter PO number",
            "Install store": "Install store",
            "WO status": "WO status",
            "Tech name": "Tech name",
            "Problem codes": "Problem codes",
            "Install customer": "Install customer",
            "WO priority": "WO priority",
            "PO due date": "PO due date",
            "MFG part #": "MFG part #",
            "MFG ID": "MFG ID",
            "Open qty": "Open qty",
            "ASN qty": "ASN qty",
            "Invoiced qty": "Invoiced qty",
            "Unit price ($)": "Unit price ($)",
            "REQ ID": "REQ ID",
            "Freight provider": "Freight provider",
            "Enter tracking no": "Enter tracking no",
            "ASN ship date": "ASN ship date",
            "Problem code": "Problem code",
            "Expedite comments": "Expedite comments",
            "Add attachments": "Add attachments",
            "View": "View",
            "Cancel item": "Cancel item",
            "Files": "Files",
            "File name exceeds limit.Please shorten or remove teh files": "File name exceeds limit.Please shorten or remove teh files",
            "Selected file is already attached. Please upload another file": "Selected file is already attached. Please upload another file",
            "You can choose only the Image (jpgC-O-M-M-A jpegC-O-M-M-A \r\npng) and PDF files": "You can choose only the Image (jpgC-O-M-M-A jpegC-O-M-M-A \r\npng) and PDF files",
            "Vendor detail": "Vendor detail",
            "Vendor loc": "Vendor loc",
            "Contact": "Contact",
            "Entered by": "Entered by",
            "Your item has been cancelled successfully": "Your item has been cancelled successfully",
            "Error occurred while updating": "Error occurred while updating",
            "PO line details updated successfully": "PO line details updated successfully",
            "Must include T at start and ( ) as the 12th character": "Must include T at start and ( ) as the 12th character",
            "Must include 1 at start and (Z) as the 2nd character": "Must include 1 at start and (Z) as the 2nd character",
            "Not a valid FEDEX tracking number": "Not a valid FEDEX tracking number",
            "Not a valid UPS tracking number.": "Not a valid UPS tracking number.",
            "Error in inserting the rating. Please contact SDI": "Error in inserting the rating. Please contact SDI",
            "Supplier call-in": "Supplier call-in",
            "Search Panel": "Search panel",
            "Unselect All": "Unselect All",
            "Please enter a WO# to continue": "Please enter a WO# to continue",
            "Manufacturer part number is required to check the catalog": "Manufacturer part number is required to check the catalog",
            "Qty ": "Qty ",
            "Proceed": "Proceed",
            "No attributes available": "No attributes available",
            "Owner": "Owner",
            "Qty On Hand": "Qty on hand",
            "Total Qty Reserved/Not Shipped": "Total qty reserved/Not shipped",
            "Defect Loc": "Defect loc",
            "Qty Available": "Qty available",
            "Defect Loc": "Defect Loc",
            "Qty Bin": "Qty bin",
            "Qty Reserved Not Picked": "Qty reserved not picked",
            "Pack Qty": "Pack qty",
            "Area": "Area",
            "Aisle": "Aisle",
            "Row": "Row",
            "Shelf": "Shelf",
            "Bin": "Bin",
            "Please rate this item": "Please rate this item",
            "Write a review": "Write a review",
            "Item Details": "Item Details",
            "Alternate Parts": "Alternate parts",
            "Please enter password": "Please enter password",
            "Password must be within 128 characters!": "Password must be within 128 characters!",
            "Item": "Item",
            "This": "This",
            "More": "More", 
            "Less": "Less",
            "Are you sure you want to reset your password?": "Are you sure you want to reset your password?",
            "Are you sure you want to cancel the order?": "Are you sure you want to cancel the order?",
            "Catalog Description": "Catalog Description",
            "Client Description": "Client Description",
            "Receiving Report": "Receiving Report",
            "My Profile": "My Profile",
            "Incidents": "Incidents",
            "Incident": "Incident",
            "Container Packing": "Container Packing",
            "Container packing": "Container packing",
            "Refresh": "Refresh",
            "Links are for reference information only.\nDo not place orders from suppliers site.": "Links are for reference information only.\nDo not place orders from suppliers site.",
            "All Categories": "All Categories",
            "Min Order Quantity": "Min Order Quantity",
            "My favorite order": "My favorite order",
            "My favorite item": "My favorite item",
            "Supplier Suggestion": "Supplier Suggestion",
            "Search for product": "Search for product",
            "You can choose only the Image files!!": "You can choose only the Image files",
            "The Item you have chosen has a CORE RETURN REQUIREMENT, a CORE Charge fee will be charged at time of purchase and refunded upon return of the associated CORE to the supplier.": "The Item you have chosen has a CORE RETURN REQUIREMENT, a CORE Charge fee will be charged at time of purchase and refunded upon return of the associated CORE to the supplier.",
            "By choosing to PROCEED, You acknowledge that you will ensure the CORE is returned as required!": "By choosing to PROCEED, You acknowledge that you will ensure the CORE is returned as required!",
            "Added to favorite pages": "Added to favorite pages",
            "Removed from favorite pages": "Removed from favorite pages",
            "Showing results for your image": "Showing results for your image",
            "Choose File": "Choose File",
            "Tracking Number Update": "Tracking Number Update",
            "Favorite item inserted sucessfully": "Favorite item inserted sucessfully",
            "Please provide the reason for selecting this supplier": "Please provide the reason for selecting this supplier",
            "Add to favorite item": "Add to favorite item",
            "Item Image Detail": "Item Image Detail",
            "Qty Reserved/Not Picked": "Qty Reserved/Not Picked",
            "Choose Your Own image": "Choose Your Own image",
            "Enter Sub Category": "Enter Sub Category",
            "A maximum of 10 forms can be included per item.": "A maximum of 10 forms can be included per item.",
            "Quantity filled": "Quantity filled",
            "Please fill all the mandatory fields": "Please fill all the mandatory fields",
            "The entered quantity does not match the requested quantity": "The entered quantity does not match the requested quantity",
            "The maximum number of forms has been reached. Please adjust the quantity or place a separate order.": "The maximum number of forms has been reached. Please adjust the quantity or place a separate order.",
            "No file is selected": "No file is selected",
            "MFG": "MFG",
            "MFG part": "MFG part",
            "Sent for Sourcing": "Sent for Sourcing",
            "Search suggestion": "Search suggestion",
            "Sub Category": "Sub category",
            "Enter Category": "Enter category",
            "Do you want to add Image for this item?": "Do you want to add Image for this item?",
            "Comments": "Comments",
            "Enter comments": "Enter comments",
            "Reason type": "Reason type",
            "--Select Ship To--": "--Select Ship To--",
            "Order Approval": "Order Approval",
            "or": "or",
            "Your account is inactive. Please contact the help desk at ***-***-*** to reinstate your account.": "Your account is inactive. Please contact the help desk at ***-***-*** to reinstate your account.",
            "Your account has been disabled due to excessive invalid login attempts.Please contact the help desk at": "Your account has been disabled due to excessive invalid login attempts.Please contact the help desk at",
            "Your account has been inactivated please contact the help desk at": "Your account has been inactivated please contact the help desk at",
            "to reinstate your account.": "to reinstate your account.",
            "Invalid ID/password": "Invalid ID/password"
        }
    },
    fr: {
        translation: {
            "Site language": "Langue du site",
            "Approvals": "Approbations",
            "Welcome": "Bienvenue à React et react-i18next",
            "WelcomeKey": "Bienvenue",
            "Number": "Nombre",
            "Back": "Précédent",
            "Sign in with ": "Connectez-vous avec ",
            "No record": "Aucun enregistrement",
            "Non-priority": "Non prioritaire",
            "Business": "Entreprise",
            "Unit": "Unité",
            "Delivery": "Livraison",
            "Need by Date": "Besoin par date",
            "Name": "Nom",
            "Requisition": "Réquisition",
            "Price": "Prix",
            "Decline": "Déclin",
            "Total": "Total",
            "Created": "Établi",
            "Waiting": "Attendre",
            "Pending Approver": "Approbateur en attente",
            "Division": "Division",
            "Region": "Région",
            "Sub Region": "Sous-région",
            "Export to Excel": "Exporter vers Excel",
            "Buy Checked Items": "Acheter des articles cochés",
            "Status": "Statut",
            "Install": "Installer",
            "Filter": "Filtrer",
            "Apply": "Présenter une demande",
            "Preference": "Préférence",
            "Select Report": "Sélectionnez le rapport (par date de commande)",
            "Select Report (by Order date)": "Sélectionnez le rapport (par date de commande)",
            "Zip Code": "Code postal",
            "Model": "Modèle",
            "Store": "Magasin",
            "Please enter": "Veuillez sélectionner",
            "Enter valid WorkOrder number": "Entrez un numéro de bon de travail valide",
            "Make": "Faire, construire",
            "Pre_filter": "Pré-filtre",
            "Itemaddedtocart_key": "L'article a été ajouté au panier",
            "SearchQuickItem_key": "Recherche par saisie rapide d'articles",
            "Required_key": "Obligatoire",
            "done_key": "terminé",
            "more_key": "Suite",
            "save_key": "sauver",
            "reset_key": "réinitialiser",
            "Attachment": "Pièce jointe",
            "part number": "Numéro d'article",
            "unitofmeasure_key": "Unité de mesure",
            "recommended": "conseillé",
            "Vendor": "Vendeur",
            "orderedfor_key": "Commandé pour",
            "orderenteredby_key": "Commande saisie par",
            "Priority": "Priorité",
            "workorder_key": "Demande de service",
            "order_key": "Ordre",
            "Quick Item Entry": "Saisie rapide d'articles",
            "Items have to be from the same supplier for pickup to be enabled": "Les articles doivent provenir du même fournisseur pour que le ramassage soit activé",
            "Pickup": "Ramassage",
            "Customer Notes": "Remarques client",
            "Edit": "Éditer",
            "Favorite": "Favori",
            "Bill-to-Store": "Facturation au magasin",
            "Ship To": "Expédier à",
            "Delivery Date": "La date de livraison",
            "Asset Tag ID": "ID d'étiquette d'actif",
            "Employee": "Employé",
            "Details": "Détails",
            "Item": "Article",
            "Shopping Cart": "paniers d'achats",
            "Download": "Télécharger",
            "Archive": "Archiver",
            "Date": "Date",
            "Title": "Titre",
            "Notification": "Notification",
            "Number of Records": "Nombre d'enregistrements",
            "Quantity": "Quantité",
            "Action": "action",
            "Your": "Ton",
            "Description": "Descriptif",
            "Category": "Catégorie",
            "ID": "Tous",
            "Continue Shopping": "Continuer vos achats",
            "Return to ": "retour aux",
            "New": "nouveau",
            "In the absence of written agreement to the contrary between customer and SDI, all pricing contained in this catalog is subject to change by SDI at any time without notice.": "Sauf accord écrit contraire entre le client et SDI, tous les prix contenus dans ce catalogue peuvent être modifiés par SDI à tout moment et sans préavis.",
            "Profile": "profile",
            "Home": "Acceuil",
            "Update": "Mettre à jour",
            "Enable": "Activer",
            "Crib Identifier": "Identifiant du berceau",
            "Block Price Display": "Affichage du prix de bloc",
            "Client": "Client",
            "Catalog": "Catalogue",
            "Cancel": "Annuler",
            "Submit": "Soumettre",
            "Approval": "Approbation",
            "Customer": "Client",
            "Partial Received": "Partiellement reçu",
            "Approve": "Approuver",
            "Information": "Information",
            "Fully Received": "Entièrement reçu",
            "Quote": "Citation",
            "Cancelled": "Annulé",
            "Rejected": "Rejeté",
            "Delivered": "Livré",
            "Complete": "Compléter",
            "Quote Approved": "Devis approuvé",
            "set": "Régler",
            "Delete": "Supprimer",
            "order_total_requiring_approval ": "Total de la commande nécessitant une approbation",
            "budg_approval_by": "Approbation budgétaire par",
            "Address": "Adresse",
            "f_name": "Prénom",
            "type": "Taper",
            "Phone": "téléphone",
            "l_name": "Nom de famille",
            "Deselect": "Désélectionner",
            "user_group": "Groupe d'utilisateurs",
            "Expand": "Développer",
            "Collapse": "S'effondrer",
            "Role": "Rôle",
            "Site": "Site",
            "dept": "département",
            "User": "Utilisateur",
            "change_pwd": "Changer le mot de passe",
            "Add": "Ajouter",
            "Zeus": "Zeus",
            "Mobility": "Mobilité",
            "Preferences": "Préférences",
            "emails": "Courriels",
            "Product": "Produit",
            "My": "Mon",
            "Logout": "Déconnexion",
            "term_of_purchase": "Conditions d’achat",
            "answer_lab": "Laboratoire de réponses",
            "f_p": "Page favorite",
            "Account": "Compte",
            "Selection": "Sélection",
            "Select": "Sélectionner",
            "Clear": "Effacer",
            "test_site": "",
            "inv_supplier": "FOURNISSEURS D'INVENTAIRE",
            "will_call_supplier": "FOURNISSEURS WLL-CALL",
            "Parts List": "Liste des pieces",
            "Supplier": "Le fournisseur",
            "Manufacturer": "Fabricant",
            "Mode": "Mode",
            "r_a": "Approbation du demandeur",
            "Help": "aide",
            "Tech Hub": "Centre technique",
            "order_status": "Statut de la commande",
            "Non-Catalog Request": "Demande hors catalogue",
            "punch_out": "Coup de poing",
            "Maintenance": "Entretien",
            "Privileges": "Privilèges",
            "Entry": "Entrée",
            "Reason": "Raison",
            "ChooseFile": "Choisir le fichier",
            "Archived": "Archivé",
            "Page": "Page",
            "Total Items": "Articles au total",
            "Location": "Emplacement",
            "Summary": "Sommaire",
            "Confirm": "Confirmer",
            "Over Pick": "Au-dessus de la sélection",
            "Under Pick": "Sous Choisir",
            "Zero Pick": "Choix zéro",
            "Yes": "Oui",
            "No": "Non",
            "Order": "Ordre",
            "Picking Items": "Cueillette d'articles",
            "Info": "Info",
            "Select a site": "Sélectionnez un site",
            "Item ID": "ID de l'article",
            "Action Code": "Code d'action",
            "Utilization Code": "Code d'utilisation",
            "Forecast Family": "Famille de prévisions",
            "Zero On Hand": "Zéro en main",
            "Replenish Type": "Type de réapprovisionnement",
            "Replenish": "Remplir",
            "Replenish Class": "Reconstituer la classe",
            "In Business Unit": "Dans l'unité commerciale",
            "Business Unit": "Unité d'affaires",
            "Replenish Status": "Statut de réapprovisionnement",
            "Not On Order": "Pas en commande",
            "Cost": "Coût",
            "Extended Cost": "Coût étendu",
            "Process Replen": "Processus de réapprovisionnement",
            "Average On Hand": "Moyenne en main",
            "Growth": "Croissance",
            "Order Forecast Model": "Modèle de prévision de commande",
            "12 Month Forecast": "Prévision sur 12 mois",
            "Month's Usage": "Utilisation du mois",
            "Next Order Date": "Date de la prochaine commande",
            "Next Order Qty": "Qté de la prochaine commande",
            "Data Posponed": "Données reportées",
            "Review": "révision",
            "Days On Hand": "Jours disponibles",
            "Excess Units": "Unités excédentaires",
            "Excess Dollars": "Dollars excédentaires",
            "Receiveing Cost": "Coût de réception",
            "Service Level": "Niveau de service",
            "Max Weeks": "Semaines max.",
            "Carrying Cost": "Coût de possession",
            "Item Stock Type": "Type de stock d'articles",
            "Safety stock": "Stock de Sécurité",
            "Package Size": "Taille du paquet",
            "Max Capacity": "Capacité maximale",
            "Lead-Time": "Délai de mise en œuvre",
            "Optimal Order QTY": "Quantité de commande optimale",
            "Current On Hand": "Actuel disponible",
            "Open PO Qty": "Quantité de bon de commande ouverte",
            "Reserved Qty": "Quantité réservée",
            "Min": "Min",
            "Open": "Ouvert",
            "Suggested Min": "Min suggéré",
            "Backorder": "Commande différée",
            "Max": "Max",
            "Suggested Max": "Max suggéré",
            "Default Putaway": "Rangement par défaut",
            "Date Added": "date ajoutée",
            "Critical Spare": "Pièce de rechange critique",
            "Supplier Part Number": "Numéro de pièce du fournisseur",
            "Last Issues Date": "Date des derniers numéros",
            "Client Stock Type": "Type d'action du client",
            "Inventory Days On Hand": "Jours d'inventaire disponibles",
            "Item Has Been Updated Successfully": "L'article a été mis à jour avec succès",
            "Ok": "D'accord",
            "Mismatch": "Décalage",
            "Cycle Count": "Nombre de cycles",
            "Standard Leadtime": "Délai d'exécution standard",
            "Machine Number": "Numero de machine",
            "Drawing": "Dessin",
            "Machine Control Num": "Numéro de commande de la machine",
            "Purchasing Dept Spec": "Spécifications du service des achats",
            "Regrind": "Rebroyé",
            "First": "D'abord",
            "Issue": "Problème",
            "Charge": "Charger",
            "Code": "Code",
            "Replenish": "Remplir",
            "Reorder Paint": "Recommander de la peinture",
            "Modifiers": "Modificateurs",
            "Attributes": "Les attributs",
            "Path": "Chemin",
            "Noun": "Nom",
            "Store Room": "Débarras",
            "No attributes avaliable": "Aucun attribut disponible",
            "Total Order Qty": "Total Order Qty",
            "Article Number": "Numéro de l'article",
            "No. of Pieces": "Nombre de pièces",
            "Material": "Matériel",
            "Owned By": "Possédé par",
            "Package": "Emballer",
            "Features": "Caractéristiques",
            "Cycle Count Reconciliation": "Rapprochement d'inventaire tournant",
            "Variance": "Variance",
            "Reconciliation Tag": "Balise de rapprochement",
            "Item Ready For Update": "Article prêt pour la mise à jour",
            "Finalization": "Finalisation",
            "Load Recon": "Charger la reconnaissance",
            "Counting Event": "Compter l'événement",
            "Entered Item Count": "Nombre d'articles saisi",
            "Bin": "Poubelle",
            "Equipment Tag": "Étiquette d'équipement",
            "Inspection Required": "Inspection requise",
            "Hazard": "Risquer",
            "Tracking": "Suivi",
            "Ship Via": "Transporté par",
            "In": "Dans",
            "Ship Date": "Date d'expédition",
            "Years": "Années",
            "Months": "Mois",
            "Select Duration": "Sélectionnez la durée",
            "Receive Items": "Recevoir des articles",
            "Inventory Management System": "Système de gestion des stocks",
            "Search containing value limit to date range entered above": "Recherche contenant la limite de valeur à la plage de dates saisie ci-dessus",
            "Search containing value but limit to last 6 months": "Recherche contenant une valeur mais limitée aux 6 derniers mois",
            "Search exact value": "Rechercher la valeur exacte",
            "Orders": "Ordres",
            "Search by": "Recherché par",
            "date range is limited to 3 months": "la plage de dates est limitée à 3 mois",
            "To": "À",
            "From": "De",
            "Report": "Signaler",
            "Order Date": "Date de commande",
            "Items": "Articles",
            "Lookup": "Chercher",
            "Check": "Vérifier",
            "WAREHOUSE": "Entrepôt",
            "Categories": "Catégories",
            "No Search Result found": "Aucun résultat de recherche trouvé",
            "Did you mean": "Vouliez-vous dire",
            "You searched for": "vous avez recherché",
            "Search Result": "Résultat de la recherche",
            "Received": "A reçu",
            "Search": "Chercher",
            "supplier_callin": "Appel du fournisseur",
            "Email Address": "Adresse e-mail",
            "Password": "Mot de passe",
            "Confirm Password": "Confirmez le mot de passe",
            "Privilege": "Privilège ",
            "A la Carte": "À la carte",
            "Program Tree View": "Arborescence du programme",
            "Program": "Programme",
            "Freight Provider :": "Fournisseur de fret :",
            "History": "Historique",
            "Buy again :": "Acheter à nouveau :",
            "Expected": "Attendu",
            "Last Updated On": "Dernière mise à jour le",
            "Pending": "En attente",
            "Counted": "Dénombré",
            "Indicates Inventory Order": "Indique la commande d'inventaire",
            "Stock Value Report": "Rapport sur la valeur de l'inventaire",
            "Select": "Sélectionner",
            "GO": "ALLER",
            "Show Bin Loc": "Spectacle Bin Loc",
            "Include Quantity On Hand": "Inclure la quantité en main",
            "ItemKey": "Article",
            "Planner CD": "CD de l'agenda",
            "On Hand": "À portée de main",
            "Currency": "Monnaie",
            "Run": "Courir",
            "Count": "Compter",
            "Avail": "Profiter",
            "Crib": "Crèche",
            "Aisle": "Rayon",
            "Row": "Ligne",
            "Shelf": "Étagère",
            "Reserv": "Réserver",
            "Actual": "Réel",
            "See not updated items": "Voir les éléments non mis à jour",
            "Change": "Changer",
            "Add": "Ajouter",
            "Track": "Pister",
            "Current": "Courant",
            "Added On": "Ajouté le",
            "Other": "Autre",
            "Approved": "Approuvé",
            "Waiting Approval Chain": "Chaîne d'approbation en attente",
            "No Records found": "aucune information disponible",
            "All": "Tous",
            "AllKey": "Tous",
            "Image": "Image",
            "Waiting Order Approval": "Approbation de la commande en attente",
            "Advanced": "Avancée",
            "Stock": "Stocker",
            "UnDelete": "Annuler la suppression",
            "Line": "Ligne",
            "Do you want to remove this item?": "Voulez-vous supprimer cet élément ?",
            "Favorites": "Favoris",
            "Show": "Spectacle",
            "Start": "Début",
            "End": "Finir",
            "Search Criteria": "Critères de recherche",
            "Contains": "Contient",
            "Search": "Chercher",
            "Any": "Tout",
            "Remaining": "Restant",
            "Returned": "Revenu",
            "Reason": "Raison",
            "Short": "Court",
            "Ship From": "Expédier de",
            "Serial": "En série",
            "Total Dollars": "Total des dollars",
            "Signature": "Signature",
            "Exceeded Budget": "Budget dépassé",
            "Stock Issues Report": "Rapport sur les émissions d'actions",
            "Header": "Entête",
            "Due": "Dû",
            "Request by": "Demandé par",
            "Reject": "Rejeter",
            "Purchase": "Acheter",
            "Enter NONE If Asset ID Not Available": "Entrez AUCUN si l'ID d'actif n'est pas disponible",
            "Notes": "Remarques",
            "Inventory": "Inventaire",
            "Get Data": "Obtenir des données",
            "Days": "Jours",
            "Exclude Non - Variance": "Exclure la non-variance",
            "Analysis": "Une analyse",
            "Enable MultiSite Access": "Activer l'accès multisite",
            "User Type": "Type d'utilisateur",
            "Product Display Type": "Type d'affichage du produit",
            "Pickup From Local Supplier": "Ramassage du fournisseur local",
            "Back to Home": "De retour à la maison",
            "There is no vendors available": "Il n'y a pas de vendeurs disponibles",
            "No Vendor available": "Aucun fournisseur disponible",
            "Return": "Revenir",
            "PunchOut is not currently available for this Vendor.": "PunchOut n'est actuellement pas disponible pour ce fournisseur.",
            "A message was sent notifying site administrator of this problem.": "Un message a été envoyé informant l'administrateur du site de ce problème.",
            "We apologize for this inconvenience.": "Nous nous excusons pour ce désagrément.",
            "Click on vendor's logo below to start browsing their catalog.": "Cliquez sur le logo du fournisseur ci-dessous pour commencer à parcourir leur catalogue.",
            "Error": "Erreur",
            "Partner Vendor": "Fournisseur partenaire",
            "Non-Catalog Orders require an additional process and you will be notified via email when your quote is available.At which point you will need to come back to this catalog to approve for final procession.": "Les commandes hors catalogue nécessitent un processus supplémentaire et vous serez averti par e-mail lorsque votre devis sera disponible. À ce moment-là, vous devrez revenir à ce catalogue pour approuver la procession finale.",
            "Check Catalog": "Consulter le catalogue",
            "Cheaper Option": "Option moins chère",
            "Part": "Partie",
            "No, thanks.": "Non merci.",
            "Cheaper Item": "Article moins cher",
            "Add To Cart": "Ajouter au panier",
            "Item you choose": "Article que vous choisissez",
            "Proceed with this item": "Continuer avec cet article",
            "Enter valid WO number": "Entrez un numéro d'OF valide",
            "contact sdi customer care": "contacter le service client sdi",
            "Call us": "Appelez-nous",
            "All rights reserved.": "Tous droits réservés.",
            "Not": "Pas",
            "You don't have Permission to": "Vous n'avez pas l'autorisation de",
            "Access this page": "Accéder à cette page",
            "Bin Label Printing": "Impression d'étiquettes de bacs",
            "Area": "Superficie",
            "OR": "OU",
            "Default": "Défaut",
            "Request Forgotten Password": "Demander un mot de passe oublié",
            "Reset Password": "Réinitialiser le mot de passe",
            "Password will be reset and sent to the email address that was set up in the Login profile for the Login ID entered above.": "Le mot de passe sera réinitialisé et envoyé à l'adresse e-mail qui a été configurée dans le profil de connexion pour l'ID de connexion saisi ci-dessus.",
            "Back To Login": "Retour à la connexion",
            "Log in to your account": "Connectez-vous à votre compte",
            "Login": "Connexion",
            "Forgot Password": "Mot de passe oublié",
            "Requested": "Demandé",
            "Print": "Imprimer",
            "Quantity On Hand": "Quantité en stock",
            "Quick Confirm": "Confirmation rapide",
            "Session Timeout": "Expiration de la session",
            "Go to login": "Aller à la connexion",
            "Online Catalog Load": "Chargement du catalogue en ligne",
            "Loading ...Please Wait": "Chargement, veuillez patienter",
            "Site Under Contruction": "Site en construction",
            "Will be Back Soon!": "Sera bientôt de retour !",
            "Place Order": "Passer la commande",
            "Rush Order": "Commande urgente",
            "Product Replenishment": "Réapprovisionnement du produit",
            "Items currently in Cart": "Articles actuellement dans le panier",
            "Count Event": "Compter l'événement",
            "Before": "Avant",
            "After": "Après",
            "Standard": "Standard",
            "Dollars": "Dollars",
            "Edit Favorites": "Éditer les favoris",
            "Add New Favorites": "Ajouter de nouveaux favoris",
            "Do you want to remove this order ?": "Voulez-vous supprimer cette commande ?",
            "Related site data not available at this time.": "Les données du site associées ne sont pas disponibles pour le moment.",
            "Net Received": "Net reçu",
            "Transaction": "Transaction",
            "Operator Entered By": "Opérateur saisi par",
            "Receiver": "Destinataire",
            "Extended Client Description": "Description étendue du client",
            "Contact Us": "Nous contacter",
            "Main Menu": "Menu principal",
            "Receiving": "Réception",
            "Picking": "Cueillette",
            "Sorry, we couldn’t find any search result": "Désolé, nous n'avons trouvé aucun résultat de recherche",
            "Event": "Événement",
            "Warning": "Avertissement",
            "Not all items flagged for update. Contine?": "Tous les éléments ne sont pas signalés pour la mise à jour. Contine ?",
            "Forecast": "Prévision",
            "Update Item": "Mettre à jour l'élément",
            "Replenish Type": "Type de réapprovisionnement",
            "Replenish": "Reponer",
            "Reason for Decline": "Raison du refus",
            "Comments": "commentaires",
            "Advanced Filter": "Filtre avancé",
            "Do you want to archieve this notification ?": "Voulez-vous archiver cette notification ?",
            "Add Attachment": "Ajouter une pièce jointe",
            "Select file to attach": "Sélectionnez le fichier à joindre",
            "Would you like to use line numbers by increments of 10?": "Souhaitez-vous utiliser les numéros de ligne par incréments de 10 ?",
            "Do you want to save this as a favorite order ?": "Voulez-vous l'enregistrer en tant que commande favorite ?",
            "Attach": "Attacher",
            "Are you sure you want to cancel your order?": "Êtes-vous sûr de vouloir annuler votre commande ?",
            "These Items are not avialable.Please remove these items": "Ces articles ne sont pas disponibles. Veuillez supprimer ces articles",
            "Invoice": "Facture d'achat",
            "Packing Slips": "Bordereaux d'emballage",
            "No records to display": "Aucun enregistrement à afficher",
            "Driver": "Conducteur",
            "Truck": "Camion",
            "Ordered By": "Commander par",
            "Ship Container": "Conteneur de navire",
            "Fragile Item Signature": "Signature d'objet fragile",
            "Shipping": "Expédition",
            "Trade": "Échanger",
            "Stop ID": "Identifiant d'arrêt",
            "Trucking / Delivery From": "Camionnage / Livraison à partir de",
            "Load ID": "Charger l'identifiant",
            "The Cycle Count Accuracy for the time period": "La précision du nombre de cycles pour la période",
            "The Absolute  Accuracy for the time period": "La précision absolue pour la période de temps",
            "With a Total Dollar Difference of ": "Avec une différence totale en dollars de ",
            "is": " est ",
            "Stock Issue Report": "Rapport sur les sorties de stock",
            "Cycle Count Analysis": "Analyse de l’inventaire des cycles",
            "Favorite Orders": "Commandes favorites",
            "UserNotifications": "Notifications utilisateur",
            "RFQ Entry": "RFQ Entrée",
            "Shop Redirect": "Redirection vers la boutique",
            "Need Approve": "Besoin d'approbation",
            "Need Quote": "Besoin d'un devis",
            "Approve Quote": "Approuver le devis",
            "User Profile": "Profil de l'utilisateur",
            "Item Detail": "Détails de l'article",
            "Search Results": "Résultats de recherche",
            "Order Status": "État de la commande",
            "Supplier Call-In": "Appel du fournisseur",
            "Receive": "Recevoir",
            "CycleCount": "Nombre de cycles",
            "Recon": "Reconnaissance",
            "Replen Review": "Réviser le renouvellement",
            "Labels by Location": "Étiquettes par emplacement",
            "Order Status Report": "Rapport sur l'état de la commande",
            "Reports": "Rapports",
            "Edit Vendor Information": "Modifier les informations sur le fournisseur",
            "Edit User Information": "Modifier les informations utilisateur",
            "Edit Mexico Information": "Modifier les informations sur le Mexique",
            "Activate/Inactivate Users": "Activer/désactiver des utilisateurs",
            "Replenish Review": "Revue de réapprovisionnement",
            "Replenish review": "Revue de réapprovisionnement",
            "SDiMS Online": "SDiMS En ligne",
            "Approve Orders": "Approuver les commandes",
            "Requestor Approval": "Approbation du demandeur",
            "Favorite Item": "Article préféré",
            "Reference Site": "Site de référence",
            "Tech Reference": "Référence technique",
            "Door - DH Pace": "Porte - DH Pace",
            "Lift Truck - Coats Garage": "Chariot Élévateur - Coats Garage",
            "Lift Truck - Wiese": "Chariot élévateur - Wiese",
            "Lift Truck - HGM Liftparts": "Chariot élévateur - HGM Liftparts",
            "Last 7 Days": "Les 7 derniers jours",
            "Last 15 Days": "Les 15 derniers jours",
            "Last 30 Days": "Les 30 derniers jours",
            "Last Month": "Le mois dernier",
            "This Month": "Ce mois - ci",
            "Select ReportKey": "Sélectionnez le rapport",
            "Too Expensive (Need Cheaper Quote)": "Trop cher (besoin d'un devis moins cher)",
            "Wrong Quantities": "Mauvaises quantités",
            "No Longer Needed": "Ne sont plus nécessaires",
            "Wrong Ship To Store": "Mauvais envoi au magasin",
            "Wrong Item(s)": "Article(s) incorrect(s)",
            "Expand All": "Développer tout",
            "Collapse All": "Tout réduire",
            "Quick Item Entry": "Saisie rapide d'articles",
            "Items from different Inventory Business Units cannot be added to same cart": "Les articles de différentes unités commerciales d'inventaire ne peuvent pas être ajoutés au même panier",
            "Do you want to clean the cart?": "Voulez-vous nettoyer le chariot ?",
            "SDI MRO for a more": "SDI MRO pour une entreprise plus ",
            "connected ": "connectée",
            " enterprise ": "",
            "Speed to Execution": "Vitesse d'exécution",
            "Simplify": "Simplifier",
            "Commitment": "Engagement",
            "Perseverance": "Persévérance",
            "Courage": "Courage",
            "Solution-Oriented": "Axée sur les solutions",
            "Check Order Status": "Vérifier l'état des commandes",
            "Favorite Item Maintanance": "Entretien de l'article préféré",
            "Non Catalog Request": "Requisition de piece non-catalogue",
            "UserProfile": "Profile de l'utilisateur",
            "Non-Catalog Request Entry": "Entrée de demande hors catalogue",
            "SDI Stock Issues Report": "SDI Rapport sur les émissions d'actions",
            "Product Replen": "Remplissage du produit",
            "Receive Items": "Recevoir des articles",
            "Picking Items": "Cueillette d'articles",
            " Non-Catalog Orders require an additional process and you will be notified via email when your quote is available. At which point you will need to come back to this catalog to approve for final procession.": "Les commandes hors catalogue nécessitent un processus supplémentaire et vous serez averti par e-mail lorsque votre devis sera disponible. À ce moment-là, vous devrez revenir à ce catalogue pour approuver la procession finale.",
            "Catalog Search": "Recherche dans le catalogue",
            "My Account": "mon compte",
            "If the data provided is correct, you will receive an email with password reset instructions": "Si les données fournies sont correctes, vous recevrez un e-mail avec les instructions de réinitialisation du mot de passe",
            "Item Maintenance": "Entretien de l'article",
            "Enter": "Entrer",
            "Utilization type": "Type d'utilisation",
            "Note - all request for all item description modifications will be forwarded to the SDI  Catalog Department for review": "Remarque - toute demande de modification de description d'article sera transmise au service de catalogue SDI pour examen",
            "Note - all text that is entered below will be  printed on the SDI PO to the supplier": "Remarque - tout le texte saisi ci-dessous sera imprimé sur le bon de commande SDI au fournisseur",
            "Min Qty on Hand": "Quantité minimum en main",
            "Max Quantity": "Quantité maximale",
            "Modifier": "Modificateur",
            "* Employee ID": "* Identifiant de l'employé",
            "* Ship To": "* Expédier à",
            "Is This Priority?": "Est-ce la priorité ?",
            "Tax Exempt": "Exonéré d'impôt",
            "More Details": "Plus de détails",
            "  Remove": "  Supprimer",
            "Available": "Disponible",
            "Attribute": "Attribut",
            "items in": "articles dans",
            "Utilization_Code": "Code d'utilisation",
            "Signed By": "Signé par",
            "Suggested Supplier :": "Fournisseur suggéré :",
            "Supplier :": "Le fournisseur :",
            "Catalog Item Details": "Détails de l'article du catalogue",
            "Non Catalog Item Details": "Détails des articles hors catalogue",
            "Manufacture": "Fabrication",
            "Show Extended Description": "Afficher la description détaillée",
            "Catalog Details": "Détails du catalogue",
            "Non Catalog Details": "Détails hors catalogue",
            "PO Header Status:": "Statut de l'en-tête du bon de commande :",
            "Close": "proche",
            "Supplier Name": "Nom du fournisseur",
            "Supplier Part#": "Pièce du fournisseur #",
            "Supplier Part #": "Pièce du fournisseur #",
            "Zeus ID": "Zeus ID",
            "Select All": " Tout sélectionner",
            "View My Selection": "Voir ma sélection",
            "Tech Vault": "Coffre-fort technologique",
            "All": "Tous",
            "Notification ID": "Notification ID",
            "Type": "Type",
            "Title": "Title",
            "Archive All": "Sauvegarder",
            "Archive Notification": "Notification d’archivage",
            "Archived Notification": "Notification d’archivage",
            "Profile Update": "Mise à jour du profil",
            "User ID": " Nom d’utilisateur",
            "Search User": "Utilisateur de recherche",
            "User details": "Détails de l'utilisateur",
            "User privileges": "Privilèges utilisateur",
            "Program Tree View": "Vue de l’arborescence du programme",
            "Privilege type": " Type de privilège",
            "Alternate Requestor Approval": "Approbation d’un autre demandeur",
            "Alternate Requestor Approval by": "Approbation d’un autre demandeur par",
            "Remove": " Supprimer",
            "Order Status Emails": " E-mails d’état de commande",
            "Waiting Approval Chain": "Chaîne d’approbation en attente",
            "Waiting Customer Approval": "Attente de l’approbation du client",
            "Requestor Approval": " Approbation du demandeur",
            "Customer Information": "Informations sur le client",
            "Vendor Information": "Informations sur le fournisseur",
            "Quote Approved": " Devis approuvé",
            "Quote Rejected": " Citation Rejetée",
            "RFQ Approved": " Approbation de l’appel d’offres",
            "RFQ Complete": " Appel d’offres terminé",
            "Fully Received": " Entièrement reçu",
            "Partial Received": " Partiellement reçue",
            "Default Ship To": "Expédier par défaut à",
            "Home store": "Magasin à domicile",
            "Crib Identifier": " Identificateur de la salle de stockage",
            "Enable Zeus": " Activer Zeus",
            "Disable Zeus": " Désactiver Zeus",
            "User information has been modified and saved successfully.": "Les informations utilisateur ont été modifiées et enregistrées avec succès.",
            "Error - password has already been used": "Erreur - le mot de passe a déjà été utilisé",
            "User ID already exists": "L’ID utilisateur existe déjà",
            "Invalid User ID": "Nom d’utilisateur non valide",
            "Technical issue": "Problème technique",
            "Equipment": "équipement",
            "WO#_History": "Histoire de l’Adj #",
            "Sub_category": "Sous-catégorie",
            "Filter records": "Filtrer les enregistrements",
            "Please select any fields to view the equipments": "Veuillez sélectionner n’importe quel champ pour voir les équipements",
            "Please enter a WO# to continue": "Veuillez entrer un Adj # pour continuer",
            "Adding an item will remove the current items in your shopping cart. Do you want to proceed with this change?": "L’ajout d’un article supprimera les articles actuels de votre panier. Voulez-vous procéder à ce changement?",
            "Confirmation": "Confirmation",
            "Item successfully added to cart": "Article ajouté au panier avec succès",
            "Punchout Catalog": "Catalogue Punchout",
            "Enter Login Id": "Entrez l’identifiant de connexion",
            "Enter Email Address": "Entrez l’adresse courriel",
            "Enter Old Password": "Entrez l’ancien mot de passe",
            "Enter New Password": "Entrez un nouveau mot de passe",
            "Enter Confirm Password": "Entrez le mot de passe de confirmation",
            "Please enter your zeus ID and password": "Veuillez saisir un identifiant et un mot de passe Zeus",
            "Please enter zeus ID": "Veuillez entrer l'ID de Zeus",
            "Please enter a password": "Veuillez entrer un mot de passe",
            "Old Password is required": "L’ancien mot de passe est requis",
            "New Password is required": "Un nouveau mot de passe est requis",
            "Confirm Password is required": "Confirmez que le mot de passe est requis",
            "Password doesn't match": "Le mot de passe ne correspond pas",
            "Warning!\nYou do not have permission to access the application": "Avertissement!\nVous n’avez pas l’autorisation d’accéder à l’application",
            "Please enter required fields": "Veuillez entrer les champs obligatoires",
            "If the data provided is correct, you will receive an email with password reset instructions": "Si les données fournies sont correctes, vous recevrez un e-mail avec des instructions de réinitialisation du mot de passe",
            "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character. Max length for password is 128 characters.": "Le mot de passe doit contenir au moins dix caractères avec 1 chiffre, 1 majuscule, 1 minuscule, 1 caractère spécial. La longueur maximale du mot de passe est de 128 caractères.",
            "Speed to Execution": "Rapidité d’exécution",
            "Agility": "Agilité",
            "One SDI": "Un IDS",
            "Operation Excellence": "Excellence opérationnelle",
            "Courage": "Courage",
            "Invalid ID/password": "Identifiant/mot de passe invalide",
            "Zeus ID": "Identifiant Zeus",
            "Manufacturer part # ": "Pièce du fabricant #",
            "Manufacturer Part #": "Pièce du fabricant #",
            "Manufacturer name": "Nom du fabricant",
            "Recommended supplier": "Fournisseur recommandé",
            "Supplier part #": "Pièce du fournisseur #",
            "Quantity": "Quantité",
            "Unit of measure": "Unité de mesure",
            "Please enter manufacturer part #": "Veuillez entrer la pièce du fabricant #",
            "Please enter manufacturer name": "Veuillez entrer le nom du fabricant",
            "Please enter quantity": "Veuillez entrer la quantité",
            "Enter manufacturer part #": "Entrez la pièce du fabricant #",
            "Enter manufacturer name": "Entrez le nom du fabricant",
            "Enter recommended supplier": "Entrez le fournisseur recommandé",
            "Enter supplier part #": "Entrez la partie fournisseur #",
            "Enter quantity": "Entrez la quantité",
            "Attachment ": "Pièce jointe ",
            "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names.": "Vous avez dépassé la longueur totale des noms de fichiers. Veuillez ajuster votre saisie ou supprimer des noms de fichiers plus longs.",
            "Description": "Descriptif",
            "Enter Description": "Entrez la description",
            "Please enter description": "Veuillez entrer la description",
            "Order information": "Informations sur la commande",
            "Work order #": "Bon de travail #",
            "Enter work order #": "Entrez Ordre de travail #",
            " WO# History": "Historique du bon de travail",
            "Enter work order number": "Entrez le numéro de bon de travail",
            "Please select Ship to ": "Veuillez sélectionner Expédier à ",
            "Enter Valid Work Order #": "Entrez un bon de travail valide #",
            "The default Ship-To's Country Code does not match the Work Order Store Country Code.": "Le code pays par défaut de l'expédition ne correspond pas au code pays du magasin de l'ordre de travail.",
            "Order notes": "Notes de commande",
            "Enter order notes": "Saisir les notes de commande",
            "Priority ": "priorité ",
            "Item details": "Détails de l’article",
            "Cancel order": "Annuler la commande",
            "Submit Order": "Soumettre la commande",
            "Order submitted for sourcing": "Commande soumise pour sourcing",
            "Successfully added to  cart": "Ajouté au panier avec succès",
            "Technical Issue -- Contact SDI": "Problème technique -- Contacter SDI",
            "Insufficient privilege to view non-catalog request": "Privilège insuffisant pour afficher la demande hors catalogue",
            "You can choose only the Image and PDF files!!": "Vous pouvez choisir uniquement les fichiers Image et PDF!!",
            "Selected file is already attached, please try again": "Le fichier sélectionné est déjà attaché, veuillez essayer à nouveau.",
            "Please use different work order # for this panel.": "Veuillez utiliser un # de bon de travail différent pour ce panneau.",
            "Is this priority?": "Est-ce là une priorité ?",
            "Browse": "Parcourir",
            "Please enter a valid Quantity": "Veuillez saisir une quantité valide",
            " Upload": "télécharger",
            "Save": "Enregistrer",
            "Ship to": "Expédier à",
            "Technical issue please contact SDI help desk": "Problème technique, veuillez contacter le service d’assistance SDI",
            "Please select the Shipment Method": "Please select the Shipment Method",
            "Previously Purchased Items": "Articles achetés précédemment",
            "Suggestions": "Suggestions",
            "Please enter work order number": "Please enter work order number",
            "Search results will be based on your selection": "Les résultats de la recherche seront basés sur votre sélection",
            "Manage Forms": "Gérer les formulaires",
            "Ordering": "Classement",
            "Sourced Non-Catalog Entry": "Entrée hors catalogue sourcée",
            "Source non-catalog entry": "Entrée hors catalogue sourcée",
            "Procurement": "Approvisionnement",
            "Email": "Courriel",
            "Interactive Diagrams": "Diagrammes interactifs",
            "Walk-In": "Entrez",
            "Reference Site Maintenance": "Maintenance du site de référence",
            "FedEx Shipping": "Expédition FedEx",
            "Cycle Counting": "Comptage des cycles",
            "Field Inventory Workbench": "Field Inventory Workbench",
            "Release Notes Maintenance": "Maintenance des notes de mise à jour",
            "Fulfillment": "Exécution",
            "Item Master": "Fiche Article",
            "Maintain Inventory": "Tenir à jour l’inventaire",
            "SDIMS Online": "SGDDI en ligne",
            "Print Container Bar Code Labels": "Imprimer des étiquettes de code à barres de conteneur",
            "Stock Issue": "Émission de stock",
            "Return to Inventory": "Retour à l’inventaire",
            "Picking Assign To": "Prélèvement Affecter à",
            "Reprint Packing": "réimpression de l’emballage",
            "Default Putaway Location": "Emplacement de rangement par défaut",
            "Add Stock Items": "Ajouter des articles en stock",
            "Bin-to - Bin Transfer": "Transfert de bac à bac",
            "Manual Stock Adjustment": "Crosse manuelle",
            "Item Holds": "Retenue d’objets",
            "Material Storage Locations": "Emplacement d’entreposage des matériaux",
            "Express Putaway": "Rangement express",
            "Mobile Inventory Management System": "Système mobile de gestion des stocks",
            "Load Stage and Putaway": "Stade de chargement et rangement",
            "Shipments": "Expéditions",
            "Expediting": "Accélérer",
            "Open POs": "bons de commande ouverts",
            "Transaction Report": "Rapport d’opérations",
            "SDI ASN Entry": "Entrée ASN SDI",
            "PO Workbench": "Interface de bon de commande",
            "You searched for": "Vous avez recherché",
            "Search Result": "Résultat de la recherche",
            "selectWO": "Sélectionnez Adj",
            "shipsBy": "Expédié par",
            "quantity": "Quantité",
            "price": "Prix",
            "Enter WO#": "Entrez BT#",
            "Matching part details": "Détails de la pièce correspondants",
            "UOM": "UOM",
            "Warehouse": "Entrepôt",
            "Truck Stock": "Stock de camions",
            "Shipment Method": "Méthode d’expédition",
            "Equivalent Parts": "Pièces équivalentes",
            "Supplier part number": "Numéro de pièce du fournisseur",
            "MFG name": "Nom du MFG",
            "MFG part number": "Numéro de pièce MFG",
            "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?": "L’ajout d’un article supprimera les articles d’équipement de votre panier. Voulez-vous procéder à ce changement ?",
            "Entered quantity is greater than the available quantity ": "La quantité saisie est supérieure à la quantité disponible",
            "Quantity Entered Is Below The Minimum Order Quantity": "La quantité saisie est inférieure à la quantité minimale de commande",
            "Entered Quantity Does Not Match the Minimum Order Quantity Sequence": "La quantité saisie ne correspond pas à la séquence de quantité minimale de commande",
            " Item is already added in the cart ": "L’article est déjà ajouté dans le panier",
            "KENSTAN-KEY is already added to cart, only one key allow for one cart. Please go to cart to increase quantity": "KENSTAN-KEY est déjà ajouté au panier, une seule clé permet d’en avoir un seul. Veuillez aller au panier pour augmenter la quantité",
            "This item is already in the cart and has reached the maximum number of 10 forms": "Cet article est déjà dans le panier et a atteint le nombre maximum de 10 formulaires",
            " is not added to cart due to technical issue. Contact SDI customer care.": "n’a pas été ajouté au panier en raison d’un problème technique. Contactez le service client SDI.",
            "Item successfully added to cart and added item applies core charges": "L’article a été ajouté au panier et l’article ajouté applique des frais de base",
            "Item cannot be added to cart due to technical issue.Contact SDI customer care.": "L’article ne peut pas être ajouté au panier en raison d’un problème technique. Contacter le service client SDI",
            "Favorite item removed sucessfully": "Article favori supprimé avec succès",
            "You cannot decrement Below the minimum order quantity": "Vous ne pouvez pas décrémenter en dessous de la quantité minimale de commande",
            "Favorite item inserted successfully": "Article favori inséré avec succès",
            "Quantity Cannot Be Zero": "La quantité ne peut pas être égale à zéro",
            "Quantity Should Not Be Empty": "La quantité ne doit pas être vide",
            "This Kensktan lock is already in the cart. Please go to cart to increase quantity": "Cette serrure Kensktan est déjà dans le panier. Veuillez aller au panier pour augmenter la quantité",
            "This Enersys Item is already added in the cart": "Cet article Enersys est déjà ajouté au panier",
            "This Door Item is already added in the cart. Please go to cart to increase quantity": "Cet article de porte a déjà été ajouté au panier. Veuillez aller au panier pour augmenter la quantité",
            "Technical Issue Try again": "Problème technique, veuillez réessayer",
            "Long description": "Description longue",
            "Short description": "Brève description",
            "Rating": "Notation",
            "Supplier": "Fournisseur",
            "Minimum Order Quantity": "Quantité minimale de commande",
            "Delivers By": "Livré par",
            "Total Order Quantity": "Quantité totale de la commande",
            "Things to be noted while uploading an Image": "Éléments à noter lors du téléchargement d’une image",
            "1.Size should be large": "1.La taille doit être grande",
            "2.Background must be black/white": "2.L’arrière-plan doit être noir/blanc",
            "3.Should not contains any watermarks": "3.Ne doit pas contenir de filigrane",
            "4.Should contains only one part per image": "4.Ne doit contenir qu’une seule partie par image",
            "5.Should not be a hand held picture": "5.Ne doit pas être une photo à main levée",
            "User also bought": "L’utilisateur a également acheté",
            "No records found": "aucune information disponible",
            "Add Review": "Ajouter un avis",
            "Inventory": "Inventaire",
            "Attributes": "Attributs",
            "Also Fits": "Convient également",
            "Links": "Liens",
            "Image Uploaded Successfully!": "Image téléchargée avec succès!",
            "Upload failed!": "Échec du téléchargement!",
            "Confirmation": "Confirmation",
            "No reviews yet": "Pas encore d’avis",
            "Replacement batteries are not currently available through Zeus, please consult with your manager or vendor management office (VMO) or order a replacement through service channel via home office realty procurement solutions (RPS) - sorry for any inconvenience this may cause": "Les batteries de remplacement ne sont actuellement pas disponibles via Zeus, veuillez consulter votre gestionnaire ou le bureau de gestion des fournisseurs (VMO) ou commander un remplacement via le canal de service via les solutions d’approvisionnement immobilier du bureau à domicile (RPS) - désolé pour tout inconvénient que cela pourrait causer",
            "Package Quantity": "Quantité du colis",
            "Updated to Walmart Preferred Item(s)": "Mis à jour vers Article(s) préféré(s) Walmart",
            "Ship within": "Expédier à l’intérieur",
            "Add To Cart": "Ajouter au panier",
            "Thank you for your response": "Merci pour votre réponse",
            "Error in inserting the rating. Please contact SDI": "Erreur lors de l’insertion de la note. Veuillez contacter SDI",
            "Punchout Catalog": "Catalogue Punchout",
            "Work order format": "Format des bons de travail",
            "Enter work order format": "Entrez le format du bon de travail",
            "Field name in English": "Field name in French",
            "PO Workbench": "Interface de bon de commande",
            "Select or enter at least one of the following ( ) fields: Ship to locationC-O-M-M-A PO numberC-O-M-M-A Vendor nameC-O-M-M-A Install store and Work order to filter down your records": "Sélectionnez ou entrez au moins un des champs suivants ( ) : Expédier à l’emplacementC-O-M-M-A Numéro de bon de commandeC-O-M-M-A Nom du fournisseurC-O-M-M-A Installer le magasin et Bon de travail pour filtrer vos enregistrements",
            "Enter ship to location": "Entrez l’emplacement de l’expédition",
            "Enter PO number": "Entrez le numéro de bon de commande",
            "Install store": "Installer le magasin",
            "WO status": "Statut d’Adj",
            "Tech name": "Nom de la technologie",
            "Problem codes": "Codes problématiques",
            "Install customer": "Installer le client",
            "WO priority": "Priorité de l’Adj",
            "PO due date": "Date d’échéance du bon de commande",
            "MFG part #": "Pièce MFG #",
            "MFG ID": "Numéro d’identification MFG",
            "Open qty": "Qté ouverte",
            "ASN qty": "Qté de l’ASN",
            "Invoiced qty": "Qté facturée",
            "Unit price ($)": "Prix unitaire ($)",
            "REQ ID": "NUMÉRO DE DEMANDE",
            "Freight provider": "Fournisseur de transport",
            "Enter tracking no": "Entrez le numéro de suivi",
            "ASN ship date": "Date d’expédition de l’ASN",
            "Problem code": "Code du problème",
            "Expedite comments": "Accélérer les commentaires",
            "Add attachments": "Ajouter une pièce jointe",
            "View": "Voir",
            "Cancel item": "Annuler l’article",
            "Files": "Fichiers",
            "File name exceeds limit.Please shorten or remove teh files": "Le nom du fichier dépasse la limite. Veuillez raccourcir ou supprimer les fichiers",
            "Selected file is already attached. Please upload another file": "Le fichier sélectionné est déjà joint. Veuillez télécharger un autre fichier",
            "You can choose only the Image (jpgC-O-M-M-A jpegC-O-M-M-A \r\npng) and PDF files": "« Vous ne pouvez choisir que l’image (jpgC-O-M-M-A jpegC-O-M-M-A\r\npng) et des fichiers PDF »",
            "Vendor detail": "Détail du fournisseur",
            "Vendor loc": "Loc. du fournisseur",
            "Contact": "Coordonnées",
            "Entered by": "Inscrit par",
            "Your item has been cancelled successfully": "Votre article a été annulé avec succès",
            "Error occurred while updating": "Une erreur s’est produite lors de la mise à jour",
            "PO line details updated successfully": "Mise à jour réussie des détails de la ligne de bon de commande",
            "Must include T at start and ( ) as the 12th character": "Doit inclure T au début et ( ) comme 12e caractère",
            "Must include 1 at start and (Z) as the 2nd character": "Doit inclure 1 au début et (Z) comme 2e caractère",
            "Not a valid FEDEX tracking number": "Pas un numéro de suivi FEDEX valide",
            "Not a valid UPS tracking number.": "Il ne s’agit pas d’un numéro de suivi UPS valide.",
            "Error in inserting the rating. Please contact SDI": "Erreur lors de l’insertion de la note. Veuillez contacter SDI",
            "Supplier call-in": "Appel du fournisseur",
            "Search Panel": "Panneau de recherche",
            "Unselect All": "Désélectionnez tout",
            "Please enter a WO# to continue": "Entrez un BT# pour continuer",
            "Manufacturer part number is required to check the catalog": "Le numéro de pièce du fabricant est requis pour vérifier le catalogue",
            "Qty ": "QTÉ",
            "Proceed": "PROCÉDER",
            "No attributes available": "Aucun attribut disponible",
            "Owner": "Propriétaire",
            "Qty On Hand": "Quantité en stock",
            "Total Qty Reserved/Not Shipped": "Quantité totale réservée/non expédiée",
            "Defect Loc": "Défaut Loc",
            "Qty Available": "Quantité disponible",
            "Defect Loc": "Défaut Loc",
            "Qty Bin": "Qté Bin",
            "Qty Reserved Not Picked": "Qté réservée non cueillie",
            "Pack Qty": "Quantité par paquet",
            "Area": "Superficie",
            "Aisle": "Allée",
            "Row": "Ligne",
            "Shelf": "Étagère",
            "Bin": "Bac",
            "Please rate this item": "Veuillez noter cet article",
            "Write a review": "Écrire un avis",
            "Item Details": "Détails de l’article",
            "Alternate Parts": "Pièces alternatives",
            "Item": "Article",
            "This": "ceci",
            "More": "plus",
            "Less": "moins",
            "Are you sure you want to reset your password?": "Êtes-vous sûr de vouloir réinitialiser votre mot de passe?",
            "Are you sure you want to cancel the order?": "Êtes-vous sûr de vouloir annuler la commande",
            "Catalog Description": "Description du catalogue",
            "Client Description": "Description du client",
            "Receiving Report": "Réception du rapport",
            "My Profile": "Mon profil",
            "Incidents": "Incidents",
            "Incident": "Incident",
            "Container Packing": "Emballage de conteneurs",
            "Container packing": "Emballage de conteneurs",
            "Refresh": "Rafraîchir",
            "Links are for reference information only.\nDo not place orders from suppliers site.": "Les liens sont fournis à titre de référence uniquement.\nNe passez pas de commandes sur le site des fournisseurs",
            "All Categories": "Toutes les catégories",
            "Min Order Quantity": "Quantité minimale de commande",
            "My favorite item": "Mon article préféré",
            "My favorite order": "Ma commande préférée",
            "Supplier Suggestion": "Suggestion de fournisseur",
            "Search for product": "Recherche de produit",
            "You can choose only the Image files!!": "Vous pouvez choisir uniquement les fichiers image",
            "The Item you have chosen has a CORE RETURN REQUIREMENT, a CORE Charge fee will be charged at time of purchase and refunded upon return of the associated CORE to the supplier.": "L’article que vous avez choisi a une EXIGENCE DE RETOUR DE BASE, des frais de charge CORE seront facturés au moment de l’achat et remboursés lors du retour du CORE associé au fournisseur.",
            "By choosing to PROCEED, You acknowledge that you will ensure the CORE is returned as required!": "En choisissant de CONTINUER, vous reconnaissez que vous vous assurerez que le CORE est retourné comme il se doit !",
            "Added to favorite pages": "Ajouté aux pages favorites",
            "Removed from favorite pages": "Supprimé des pages favorites",
            "Showing results for your image": "Affichage des résultats pour votre image",
            "Choose File": "Choisir un fichier",
            "Tracking Number Update": "Mise à jour du numéro de suivi",
            "Favorite item inserted sucessfully": "Article favori inséré avec succès",
            "Please provide the reason for selecting this supplier": "Veuillez fournir la raison de la sélection de ce fournisseur",
            "Add to favorite item": "Ajouter aux favoris",
            "Item Image Detail": "Détail de l’image de l’article",
            "Qty Reserved/Not Picked": "Qté réservée/non cueillie",
            "Choose Your Own image": "Choisissez votre propre image",
            "Enter Sub Category": "Entrez dans la sous-catégorie",
            "A maximum of 10 forms can be included per item.": "Un maximum de 10 formulaires peut être inclus par article.",
            "Quantity filled": "Quantité remplie",
            "Please fill all the mandatory fields": "Veuillez remplir tous les champs obligatoires",
            "The entered quantity does not match the requested quantity": "La quantité saisie ne correspond pas à la quantité demandée",
            "The maximum number of forms has been reached. Please adjust the quantity or place a separate order.": "Le nombre maximum de formulaires a été atteint. Veuillez ajuster la quantité ou passer une commande séparée.",
            "No file is selected": "Aucun fichier n’est sélectionné",
            "MFG": "FABRICANT",
            "MFG part": "pièce de fabrication",
            "Sent for Sourcing": "Envoyé pour approvisionnement",
            "Search suggestion": "Suggestion de recherche",
            "Sub Category": "Sous-catégorie",
            "Enter Category": "Entrer la catégorie",
            "Do you want to add Image for this item?": "Voulez-vous ajouter une image pour cet article?",
            "Comments": "Commentaires",
            "Enter comments": "Entrez des commentaires",
            "Reason type": "Type de motif",
            "--Select Ship To--": "Sélectionnez Expédier à",
            "Order Approval": "Approbation de l’ordonnance",
            "or": "ou",
            "Your account is inactive. Please contact the help desk at ***-***-*** to reinstate your account.": "Votre compte est inactif. Veuillez communiquer avec le service d’assistance à ***-***-*** pour rétablir votre compte.",
            "Your account has been disabled due to excessive invalid login attempts.Please contact the help desk at": "Votre compte a été désactivé en raison d’un nombre excessif de tentatives de connexion non valides. Veuillez communiquer avec le service d’assistance au",
            "Your account has been inactivated please contact the help desk at": "Votre compte a été désactivé, veuillez contacter le service d'assistance à l'adresse",
            "to reinstate your account.": "pour rétablir votre compte.",
            "Invalid ID/password": "ID/mot de passe invalide"
        }
    },
    es: {
        translation: {
            "Site language":"Idioma del sitio",
            "Approvals": "Aprobaciones",
            "Welcome": "Bienvenue à React et react-i18next",
            "WelcomeKey": "Bienvenido",
            "Number": "Número",
            "Back": "Atrás",
            "Sign in with ": "Iniciar sesión con ",
            "No record": "Sin registro",
            "Non-priority": "No prioritario",
            "Business": "Negocio",
            "Unit": "Unidad",
            "Delivery": "Entrega",
            "Need by Date": "Necesidad por fecha",
            "Name": "Nombre",
            "Requisition": "Requisar",
            "Price": "Precio",
            "Decline": "Disminución",
            "Total": "Total",
            "Created": "Creado",
            "Waiting": "Esperando",
            "Pending Approver": "Aprobador pendiente",
            "Division": "División",
            "Region": "Región",
            "Sub Region": "Subregión",
            "Export to Excel": "Exportar a Excel",
            "Buy Checked Items": "Comprar artículos marcados",
            "Status": "Estado",
            "Install": "Instalar en pc",
            "Filter": "Filtro",
            "Preference": "Preferencia",
            "Select Report": "Seleccione Informe (por fecha de pedido)",
            "Select Report (by Order date)": "Seleccione Informe (por fecha de pedido)",
            "Zip Code": "Código postal",
            "Model": "Modelo",
            "Store": "Tienda",
            "Please enter": "Por favor seleccione",
            "Enter valid WorkOrder number": "Ingrese un número de orden de trabajo válido",
            "Make": "Hacer",
            "Pre_filter": "Prefiltro",
            "Itemaddedtocart_key": "El artículo ha sido añadido al carrito.",
            "SearchQuickItem_key": "Buscar por entrada de artículo rápido",
            "Required_key": "Requerido",
            "done_key": "hecho",
            "more_key": "más",
            "save_key": "Guardar",
            "reset_key": "Reiniciar",
            "attachment_key": "Adjunto archivo",
            "part number": "Número de pieza",
            "unitofmeasure_key": "Unidad de medida",
            "recommended": "Recomendado",
            "Vendor": "Vendedor",
            "orderedfor_key": "Pedido para",
            "orderenteredby_key": "Pedido ingresado por",
            "Priority": "Prioridad",
            "workorder_key": "Orden de trabajo",
            "order_key": "Orden",
            "Quick Item Entry": "Entrada rápida de artículos",
            "Items have to be from the same supplier for pickup to be enabled": "Los artículos deben ser del mismo proveedor para que se habilite la recolección",
            "Pickup": "Recoger",
            "Customer Notes": "Notas de los clientes",
            "Edit": "Editar",
            "Favorite": "Favorito",
            "Bill-to-Store": "Facturación a tienda",
            "Ship To": "Enviar a",
            "Delivery Date": "Fecha de entrega",
            "Asset Tag ID": "ID de etiqueta de activo",
            "Employee": "Empleado",
            "Details": "Detalles",
            "Item": "Artículo",
            "Shopping Cart": "Carro de compras",
            "Download": "Descargar",
            "Archive": "Archivo",
            "Date": "Fecha",
            "Title": "Título",
            "Notification": "Notificación",
            "Number of Records": "Número de registros",
            "Quantity": "Cantidad",
            "Action": "Acción",
            "Your": "Tu",
            "Description": "Descripción",
            "Category": "Categoría",
            "ID": "Todos",
            "Continue Shopping": "Continuer mes achats",
            "Return to ": "Volver a",
            "New": "Nuevo",
            "In the absence of written agreement to the contrary between customer and SDI, all pricing contained in this catalog is subject to change by SDI at any time without notice.": "En ausencia de un acuerdo por escrito en contrario entre el cliente y SDI, todos los precios contenidos en este catálogo están sujetos a cambios por parte de SDI en cualquier momento sin previo aviso.",
            "Profile": "Perfil",
            "Home": "Casa",
            "Update": "Actualizar",
            "Enable": "Permitir",
            "Crib Identifier": "Identificador de cuna",
            "Block Price Display": "Visualización de precio de bloque",
            "Client": "Cliente",
            "Catalog": "Catalogar",
            "Cancel": "Cancelar",
            "Submit": "Entregar",
            "Approval": "Aprobación",
            "Customer": "Cliente",
            "Partial Received": "Parcial recibido",
            "Information": "Información",
            "Fully Received": "Totalmente recibido",
            "Quote": "Cita",
            "Cancelled": "Cancelado",
            "Rejected": "Rechazado",
            "Delivered": "Completo",
            "Complete": "Aprobar",
            "Quote Approved": "Cotización aprobada",
            "set": "Colocar",
            "Delete": "Borrar",
            "order_total_requiring_approval ": "Total del pedido que requiere aprobación",
            "budg_approval_by": "Aprobación presupuestaria por",
            "Address": "Dirección",
            "f_name": "Primer nombre",
            "type": "Escribe",
            "Phone": "teléfono",
            "l_name": "Apellido",
            "Deselect": "Deseleccionar",
            "user_group": "Grupo de usuario",
            "Expand": "Expandir",
            "Collapse": "Colapso",
            "Role": "Papel",
            "Site": "Sitio",
            "dept": "Departamento",
            "User": "Usuario",
            "change_pwd": "Cambiar la contraseña",
            "Add": "Agregar",
            "Zeus": "Zeus",
            "Mobility": "Movilidad",
            "Preferences": "Preferencias",
            "emails": "Correos electrónicos",
            "Product": "Producto",
            "My": "Mi",
            "Logout": "Cerrar sesión",
            "term_of_purchase": "Condiciones de compra",
            "answer_lab": "Laboratorio de respuestas",
            "f_p": "Página favorita",
            "Account": "Cuenta",
            "Selection": "Selección",
            "Select": "Seleccione",
            "Clear": "Clara",
            "test_site": "Aprobar",
            "inv_supplier": "PROVEEDORES DE INVENTARIO",
            "will_call_supplier": "PROVEEDORES WLL-CALL",
            "Parts List": "Lista de partes",
            "Supplier": "Proveedor",
            "Manufacturer": "Fabricante",
            "Mode": "Modo",
            "r_a": "Aprobación del solicitante",
            "Help": "Ayuda",
            "Tech Hub": "Centro tecnológico",
            "order_status": "Estado de la orden",
            "Non-Catalog Request": "Solicitud fuera de catálogo",
            "punch_out": "Perforar",
            "Maintenance": "Mantenimiento",
            "Privileges": "Privilegios",
            "Entry": "Entrada",
            "Reason": "Razón",
            "ChooseFile": "Elija el archivo",
            "Archived": "Archivado",
            "Page": "Página",
            "page": "Página",
            "Total Items": "Articulos totales",
            "Location": "Localización",
            "Summary": "Resumen",
            "Confirm": "Confirmar",
            "Over Pick": "Sobre Pick",
            "Under Pick": "Debajo de Pick",
            "Zero Pick": "Selección cero",
            "Yes": "sí",
            "No": "No",
            "Order": "Orden",
            "Picking Items": "Selección de artículos",
            "Info": "Información",
            "Select a site": "Seleccione un sitio",
            "Item ID": "Identificación del producto",
            "Action Code": "Código de acción",
            "Utilization Code": "Código de utilización",
            "Forecast Family": "Familia de previsión",
            "Zero On Hand": "Cero disponible",
            "Replenish Type": "Tipo de reabastecimiento",
            "Replenish Class": "Reabastecer la clase",
            "In Business Unit": "En Unidad de Negocio",
            "Business Unit": "Unidad de negocio",
            "Replenish Status": "Orden",
            "Replenish Status": "Reponer estado",
            "Not On Order": "No en orden",
            "Cost": "Costo",
            "Extended Cost": "Costo extendido",
            "Process Replen": "Reposición de proceso",
            "Average On Hand": "Promedio disponible",
            "Growth": "Crecimiento",
            "Order Forecast Model": "Modelo de previsión de pedidos",
            "12 Month Forecast": "Previsión de 12 meses",
            "Month's Usage": "Uso del mes",
            "Next Order Date": "Próxima fecha de pedido",
            "Next Order Qty": "Próxima cantidad de pedido",
            "Data Posponed": "Datos aplazados",
            "Review": "revisión",
            "Days On Hand": "Días disponibles",
            "Excess Units": "Unidades en exceso",
            "Excess Dollars": "Exceso de dólares",
            "Receiveing Cost": "Recibir el costo",
            "Service Level": "Nivel de servicio",
            "Max Weeks": "Semanas máximas",
            "Carrying Cost": "Costo de transporte",
            "Item Stock Type": "Tipo de stock del artículo",
            "Safety stock": "Stock de seguridad",
            "Package Size": "Tamaño del paquete",
            "Max Capacity": "Máxima capacidad",
            "Lead-Time": "Tiempo de espera",
            "Optimal Order QTY": "Cantidad de orden óptima",
            "Current On Hand": "Actual disponible",
            "Open PO Qty": "Cantidad de orden de compra abierta",
            "Reserved Qty": "Cantidad reservada",
            "Min": "Min",
            "Open": "Abierto",
            "Suggested Min": "Mínimo sugerido",
            "Backorder": "Pedido pendiente",
            "Max": "Max",
            "Suggested Max": "Max sugerido",
            "Default Putaway": "Almacenamiento predeterminado",
            "Date Added": "Fecha Agregada",
            "Critical Spare": "Repuesto crítico",
            "Supplier Part Number": "Número de pieza del proveedor",
            "Last Issues Date": "Fecha de última emisión",
            "Client Stock Type": "Tipo de stock del cliente",
            "Inventory Days On Hand": "Días de inventario disponibles",
            "Item Has Been Updated Successfully": "El artículo se ha actualizado correctamente",
            "Ok": "OK",
            "Mismatch": "Discordancia",
            "Cycle Count": "Contador de Cíclos",
            "Standard Leadtime": "Plazo de entrega estándar",
            "Machine Number": "Número de máquina",
            "Drawing": "Dibujo",
            "Machine Control Num": "Número de control de la máquina",
            "Purchasing Dept Spec": "Especificaciones del departamento de compras",
            "Regrind": "Triturar",
            "First": "Primero",
            "Issue": "Asunto",
            "Charge": "Cargar",
            "Code": "Código",
            "Replenish": "Reponer",
            "Reorder Paint": "Reordenar pintura",
            "Modifiers": "Modificadores",
            "Attributes": "Atributos",
            "Path": "Sendero",
            "Noun": "Sustantivo",
            "Store Room": "Trastero",
            "No attributes avaliable": "No hay atributos disponibles",
            "Total Order Qty": "Total Order Qty",
            "Article Number": "Número de artículo",
            "No. of Pieces": "Numero de piezas",
            "Material": "Material",
            "Owned By": "Propiedad de",
            "Package": "Paquete",
            "Features": "Características",
            "Group": "Grupo",
            "Cycle Count Reconciliation": "Conciliación de recuento de ciclos",
           "Variance": "Diferencia",
            "Reconciliation Tag": "Etiqueta de reconciliación",
            "Item Ready For Update": "Artículo listo para actualizar",
            "Finalization": "Finalización",
            "Load Recon": "Carga Recon",
            "Counting Event": "Evento de conteo",
            "Entered Item Count": "Recuento de elementos ingresados",
            "Bin": "Compartimiento",
            "Equipment Tag": "Etiqueta de equipo",
            "Inspection Required": "Se requiere inspección",
            "Hazard": "Peligro",
            "Tracking": "Seguimiento",
            "Ship Via": "Embarcar vía",
            "In": "En",
            "Ship Date": "Fecha de envío",
            "Years": "Años",
            "Months": "Meses",
            "Select Duration": "Seleccionar duración",
            "Receive Items": "Recibir artículos",
            "Inventory Management System": "Sistema de gestión de inventario",
            "Search containing value limit to date range entered above": "Búsqueda que contiene el límite de valor para el rango de fechas ingresado arriba",
            "Search containing value but limit to last 6 months": "La búsqueda contiene valor pero se limita a los últimos 6 meses",
            "Search exact value": "Buscar valor exacto",
            "Orders": "Pedidos",
            "Search by": "Búsqueda por",
            "date range is limited to 3 months": "el rango de fechas está limitado a 3 meses",
            "To": "Para",
            "From": "De",
            "Report": "Reporte",
            "Order date": "Fecha de pedido",
            "Items": "Elementos",
            "Lookup": "Buscar",
            "Check": "Cheque",
            "WAREHOUSE": "Almacén",
            "Categories": "Categorías",
            "No Search Result found": "No se encontraron resultados de búsqueda",
            "Did you mean": "Querías decir",
            "You searched for": "Usted buscó",
            "Search Result": "Resultado de búsqueda",
            "Received": "Recibió",
            "Search": "Buscar",
            "supplier_callin": "Llamada de proveedor",
            "Email Address": "Dirección de correo electrónico",
            "Password": "Contraseña",
            "Confirm Password": "confirmar Contraseña",
            "Privilege": "Privilegio ",
            "A la Carte": "A la carta",
            "Program Tree View": "Vista de árbol del programa",
            "Program": "Programa",
            "Freight Provider :": "Proveedor de flete:",
            "History": "Historia",
            "Buy again :": "Compra otra vez :",
            "Expected": "Esperado",
            "Last Updated On": "Ultima actualización en",
            "Pending": "Pendiente",
            "Counted": "Contados",
            "Indicates Inventory Order": "Indica orden de inventario",
            "Stock Value Report": "Informe de valor de existencias",
            "Select": "Seleccione",
            "GO": "IR",
            "Show Bin Loc": "Mostrar Bin Loc",
            "Include Quantity On Hand": "Incluir cantidad disponible",
            "ItemKey": "Artículo",
            "Planner CD": "CD del planificador",
            "On Hand": "En mano",
            "Currency": "Divisa",
            "Run": "Courir",
            "Count": "Contar",
            "Avail": "Aprovechar",
            "Crib": "Cuna",
            "Aisle": "Pasillo",
            "Row": "Hilera",
            "Shelf": "Estante",
            "Reserv": "Reserv",
            "Actual": "Real",
            "See not updated items": "Ver artículos no actualizados",
            "Change": "Cambio",
            "Add": "Agregar",
            "Track": "Pista",
            "Current": "Actual",
            "Added On": "Añadido",
            "Other": "Otro",
            "Approved": "Aprobado",
            "Waiting Approval Chain": "Esperando la cadena de aprobación",
            "No Records found": "No se encontraron registros",
            "All": "Todo",

            "Image": "Imagen",
            "Waiting Order Approval": "Esperando aprobación de pedido",
            "Advanced": "Avanzado",
            "Stock": "Existencias",
            "UnDelete": "Recuperar",
            "Line": "Línea",
            "Do you want to remove this item?": "Quieres eliminar este artículo?",
            "Favorites": "Favoritos",
            "Show": "Show",
            "Start": "Comienzo",
            "End": "Fin",
            "Search Criteria": "Criterio de búsqueda",
            "Contains": "Contiene",
            "Any": "Alguna",
            "Search": "Buscar",
            "Remaining": "Restante",
            "Returned": "Devuelto",
            "Reason": "Razón",
            "Short": "Pequeño",
            "Ship From": "Nave de",
            "Serial": "De serie",
            "Total Dollars": "Dólares totales",
            "Signature": "Firma",
            "Exceeded Budget": "Presupuesto excedido",
            "Stock Issues Report": "Informe de problemas de stock",
            "Header": "Encabezamiento",
            "Due": "Vencer",
            "Request by": "Una petición de",
            "Reject": "Rechazar",
            "Purchase": "Acheter",
            "Enter NONE If Asset ID Not Available": "Ingrese NINGUNO si el ID del activo no está disponible",
            "Notes": "Notas",
            "Inventory": "Inventario",
            "Get Data": "Obtener datos",
            "Days": "Dias",
            "Exclude Non - Variance": "Excluir la no variación",
            "Analysis": "Análisis",
            "Enable MultiSite Access": "Habilitar el acceso a varios sitios",
            "User Type": "Tipo de usuario",
            "Product Display Type": "Tipo de visualización del producto",
            "Pickup From Local Supplier": "Recogida del proveedor local",
            "Back to Home": "De vuelta a casa",
            "There is no vendors available": "No hay proveedores disponibles",
            "No Vendor available": "No hay vendedor disponible",
            "Return": "Regreso",
            "PunchOut is not currently available for this Vendor.": "PunchOut no está disponible actualmente para este proveedor.",
            "A message was sent notifying site administrator of this problem.": "Se envió un mensaje notificando al administrador del sitio sobre este problema.",
            "We apologize for this inconvenience.": "Pedimos disculpas por este inconveniente.",
            "Click on vendor's logo below to start browsing their catalog.": "Haga clic en el logotipo del proveedor a continuación para comenzar a explorar su catálogo.",
            "Error": "Error",
            "Partner Vendor": "Proveedor asociado",
            "Non-Catalog Orders require an additional process and you will be notified via email when your quote is available.At which point you will need to come back to this catalog to approve for final procession.": "Los pedidos que no pertenecen al catálogo requieren un proceso adicional y se le notificará por correo electrónico cuando su cotización esté disponible. En ese momento, deberá volver a este catálogo para aprobar la procesión final.",
            "Check Catalog": "Ver catálogo",
            "Cheaper Option": "Opción más barata",
            "Part": "Parte",
            "No, thanks.": "No, gracias.",
            "Cheaper Item": "Artículo más barato",
            "Add To Cart": "Ajouter au panier",
            "Item you choose": "Artículo que eliges",
            "Proceed with this item": "Continuar con este artículo",
            "Enter valid WO number": "Ingrese un número de WO válido",
            "contact sdi customer care": "póngase en contacto con el servicio de atención al cliente de sdi",
            "Call us": "Llámanos",
            "All rights reserved.": "Todos los derechos reservados.",
            "Not": "No",
            "You don't have Permission to": "tienes permiso para",
            "Access this page": "Accede a esta pagina",
            "Bin Label Printing": "Impresión de etiquetas de contenedores",
            "Area": "Área",
            "OR": "O",
            "Default": "Defecto",
            "Request Forgotten Password": "Solicitar contraseña olvidada",
            "Reset Password": "Restablecer contraseña",
            "Password will be reset and sent to the email address that was set up in the Login profile for the Login ID entered above.": "La contraseña se restablecerá y se enviará a la dirección de correo electrónico que se configuró en el perfil de inicio de sesión para el ID de inicio de sesión ingresado anteriormente.",
            "Back To Login": "Volver al inicio de sesión",
            "Log in to your account": "Inicia sesión en tu cuenta",
            "Login": "Iniciar sesión",
            "Forgot Password": "Olvidé mi contraseña",
            "Requested": "Solicitado",
            "Print": "Impresión",
            "Quantity On Hand": "Cantidad en stock",
            "Quick Confirm": "Confirmación rápida",
            "Session Timeout": "Hora de término de la sesión",
            "Go to login": "Ir a iniciar sesión",
            "Online Catalog Load": "Carga del catálogo en línea",
            "Loading ...Please Wait": "Cargando por favor espere",
            "Site Under Contruction": "Sitio en construcción",
            "Will be Back Soon!": "¡Volveremos pronto!",
            "Place Order": "Realizar pedido",
            "Rush Order": "Orden urgente",
            "Product Replenishment": "Reabastecimiento de producto",
            "Items currently in Cart": "Artículos actualmente en el carrito",
            "Count Event": "Contar evento",
            "Before": "Antes",
            "After": "Después",
            "Standard": "Estándar",
            "Dollars": "Dolares",
            "Edit Favorites": "Editar favoritos",
            "Add New Favorites": "Ajouter de nouveaux favoris",
            "Do you want to remove this order ?": "¿Quieres eliminar este pedido?",
            "Related site data not available at this time.": "Los datos del sitio relacionados no están disponibles en este momento.",
            "Net Received": "Neto recibido",
            "Transaction": "Transacción",
            "Operator Entered By": "Operador ingresado por",
            "Receiver": "Receptor",
            "Extended Client Description": "Descripción ampliada del cliente",
            "Contact Us": "Contáctenos",
            "Main Menu": "Menú principal",
            "Receiving": "Recepción",
            "Picking": "Cosecha",
            "Sorry, we couldn’t find any search result": "Lo sentimos, no pudimos encontrar ningún resultado de búsqueda",
            "Event": "Evento",
            "Warning": "Advertencia",
            "Not all items flagged for update. Contine?": "No todos los elementos están marcados para actualización. Continente?",
            "Forecast": "Pronóstico",
            "Update Item": "Actualizar artículo",
            "Replenish Type": "Tipo de reabastecimiento",
            "Reason for Decline": "Razón del rechazo",
            "Comments": "Comentarios",
            "Advanced Filter": "Filtro avanzado",
            "Do you want to archieve this notification ?": "¿Quieres archivar esta notificación ?",
            "Add Attachment": "Agregar archivo adjunto",
            "Select file to attach": "Seleccione el archivo que desea adjuntar",
            "Would you like to use line numbers by increments of 10?": "¿Le gustaría usar números de línea en incrementos de 10?",
            "Do you want to save this as a favorite order ?": "¿Quieres guardar este pedido como favorito?",
            "Attach": "Adjuntar",
            "Are you sure you want to cancel your order?": "¿Estás seguro de que deseas cancelar tu pedido?",
            "These Items are not avialable.Please remove these items": "Estos artículos no están disponibles. Elimínelos.",
            "Invoice": "Factura",
            "Packing Slips": "Albaranes",
            "No records to display": "No hay registros que mostrar",
            "Driver": "Conductor",
            "Truck": "Camión",
            "Ordered By": "Ordenado por",
            "Ship Container": "Contenedor de barco",
            "Fragile Item Signature": "Firma del artículo frágil",
            "Shipping": "Transporte",
            "Trade": "Comercio",
            "Stop ID": "Detener ID",
            "Trucking / Delivery From": "Transporte / Entrega desde",
            "Load ID": "ID de carga",
            "The Cycle Count Accuracy for the time period": "La precisión del recuento de ciclos para el período de tiempo",
            "The Absolute  Accuracy for the time period": "La precisión absoluta para el período de tiempo",
            "With a Total Dollar Difference of ": "Con una diferencia total en dólares de ",
            "is": " es ",
            "Stock Issue Report": "Informe de emisión de existencias",
            "Cycle Count Analysis": "Análisis de conteo cíclico",
            "Favorite Orders": "Órdenes favoritas",
            "UserNotifications": "UserNotifications",
            "RFQ Entry": "RFQ Entrada",
            "Shop Redirect": "Redirigir tienda",
            "Need Approve": "Necesita aprobación",
            "Need Quote": "Necesita cotización",
            "Approve Quote": "Aprobar cotización",
            "User Profile": "Perfil del usuario",
            "Item Detail": "Detalle del artículo",
            "Search Results": "Resultados de la búsqueda",
            "Order Status": " Estado Del Pedido",
            "Supplier Call-In": "Llamada de proveedor",
            "Receive": "Recibir",
            "CycleCount": "Contador de Cíclos",
            "Recon": "Recon",
            "Replen Review": "Revisión de reposición",
            "Labels by Location": "Etiquetas por ubicación",
            "Order Status Report": "Informe de estado del pedido",
            "Reports": "Informes",
            "Edit Vendor Information": "Editar la información del proveedor",
            "Edit User Information": "Editar la información del usuario",
            "Edit Mexico Information": "Editar información de México",
            "Activate/Inactivate Users": "Activar / desactivar usuarios",
            "Replenish Review": "Revisión de reposición",
            "Replenish review": "Revisión de reposición",
            "SDiMS Online": "SDiMS En línea",
            "Approve Orders": "Aprobar pedidos",
            "Requestor Approval": "Aprobación del solicitante",
            "Favorite Item": "Artículo favorito",
            "Reference Site": "Sitio de referencia",
            "Tech Reference": "Referencia técnica",
            "Door - DH Pace": "Puerta - DH Pace",
            "Lift Truck - Coats Garage": "Carretilla elevadora - Coats Garage",
            "Lift Truck - Wiese": "Carretilla elevadora - Wiese",
            "Lift Truck - HGM Liftparts": "Carretilla elevadora - HGM Liftparts",
            "Last 7 Days": "Los últimos 7 días",
            "Last 15 Days": "Los últimos 15 días",
            "Last 30 Days": "Los últimos 30 días",
            "Last Month": "El mes pasado",
            "This Month": "Este mes",
            "Select ReportKey": "Seleccionar informe",
            "Too Expensive (Need Cheaper Quote)": "Demasiado caro(necesita una cotización más barata)",
            "Wrong Quantities": "Cantidades incorrectas",
            "No Longer Needed": "Ya no es necesario",
            "Wrong Ship To Store": "Envío incorrecto a la tienda",
            "Wrong Item(s)": "Artículos incorrectos",
            "Expand All": "Expandir todo",
            "Collapse All": "Desplegar todo",
            "Quick Item Entry": "Entrada rápida de artículos",
            "Items from different Inventory Business Units cannot be added to same cart": "Los artículos de diferentes unidades de negocio de inventario no se pueden agregar al mismo carrito",
            "Do you want to clean the cart?": "¿Quieres limpiar el carrito?",
            "SDI MRO for a more": "SDI MRO para una empresa más ",
            "connected ": "conectada",
            " enterprise ": "",
            "Speed to Execution": "Velocidad de ejecución",
            "Simplify": "Simplificar",
            "Commitment": "Compromiso",
            "Perseverance": "Perseverancia",
            "Courage": "Coraje",
            "Solution-Oriented": "Solucion orientada",
            "Check Order Status": "Comprobar el estado del pedido",
            "Favorite Item Maintanance": "Mantenimiento de artículo favorito",
            "Non Catalog Request": "Solicitud sin catálogo",
            "UserProfile": "Perfil del usuario",
            "Non-Catalog Request Entry": "Entrada de solicitud no catalogada",
            "SDI Stock Issues Report": "SDI Informe de problemas de existencias de",
            "Product Replen": "Reabastecimiento de producto",
            "Receive Items": "Recibir artículos",
            "Picking Items": "Selección de artículos",
            " Non-Catalog Orders require an additional process and you will be notified via email when your quote is available. At which point you will need to come back to this catalog to approve for final procession.": "Los pedidos que no pertenecen al catálogo requieren un proceso adicional y se le notificará por correo electrónico cuando su cotización esté disponible. En ese momento, deberá volver a este catálogo para aprobar la procesión final.",
            "Catalog Search": "Búsqueda en el catálogo",
            "My Account": "Mi cuenta",
            "If the data provided is correct, you will receive an email with password reset instructions": "Si los datos proporcionados son correctos, recibirá un correo electrónico con instrucciones para restablecer la contraseña.",
            "Item Maintenance": "Mantenimiento del artículo",
            "Enter": "Ingresar",
            "Utilization type": "Tipo de utilización",
            "Note - all request for all item description modifications will be forwarded to the SDI  Catalog Department for review": "Nota: todas las solicitudes de modificaciones en la descripción del artículo se enviarán al Departamento de catálogo de SDI para su revisión.",
            "Note - all text that is entered below will be  printed on the SDI PO to the supplier": "Nota: todo el texto que se ingrese a continuación se imprimirá en el SDI PO para el proveedor",
            "Min Qty on Hand": "Cantidad mínima disponible",
            "Max Quantity": "Cantidad máxima",
            "Modifier": "Modificador",
            "* Employee ID": "* ID de empleado",
            "* Ship To": "* Envie a",
            "Is This Priority?": "¿Es esta prioridad?",
            "Tax Exempt": "Exento de impuestos",
            "More Details": "Más detalles",
            "  Remove": "  Eliminar",
            "Available": "Disponible",
            "Attribute": "Atributo",
            "items in": "artículos en",
            "Utilization_Code": "Código de utilización",
            "Signed By": "Firmado por",
            "Suggested Supplier :": "Proveedor sugerido:",
            "Supplier :": "Proveedor:",
            "Catalog Item Details": "Detalles del artículo del catálogo",
            "Non Catalog Item Details": "Detalles de artículos que no pertenecen al catálogo",
            "Manufacture": "Fabricar",
            "Show Extended Description": "Mostrar descripción ampliada",
            "Catalog Details": "Detalles del catálogo",
            "Non Catalog Details": "Detalles sin catálogo",
            "PO Header Status:": "Estado del encabezado de la orden de compra:",
            "Close": "Cerrar",
            "Supplier Name": "Nombre del proveedor",
            "Supplier Part#": "Parte del proveedor #",
            "Supplier Part #": "Parte del proveedor #",
            "Zeus ID": " Identificación de Zeus",
            "Select All": "Seleccionar Todo",
            "Unselect All": "Anular la selección de todo",
            "View My Selection": "Ver mi selección",
            "Tech Vault": "Bóveda tecnológica",
            "All": "Todo",
            "Notification ID": "ID de notificación",
            "Type": "Escribe",
            "Title": "Titre",
            "Archive All": "Archiva todo",
            "Archive Notification": "Notificación de archivo",
            "Archived Notification": "Notificación de archivo",
            "Profile Update": "Actualización del perfil",
            "User ID": "ID de usuario",
            "Search User": "Usuario de búsqueda",
            "User details": "Detalles del usuario",
            "User privileges": "Privilegios de usuario",
            "Program Tree View": "Vista de árbol del programa",
            "Privilege type": "Tipo de privilegio",
            "Alternate Requestor Approval": "Aprobación del solicitante alternativo",
            "Alternate Requestor Approval by": "Aprobación del solicitante alternativo por",
            "Remove": " Eliminar",
            "Order Status Emails": "Correos electrónicos de estado del pedido",
            "Waiting Approval Chain": "Esperando la cadena de aprobación",
            "Waiting Customer Approval": "Esperando la aprobación del cliente",
            "Requestor Approval": "Aprobación del solicitante",
            "Customer Information": " Información del cliente",
            "Vendor Information": " Información del proveedor",
            "Quote Approved": " Cotización aprobada",
            "Quote Rejected": " Cotización Rechazada",
            "RFQ Approved": " RFQ Aprobado",
            "RFQ Complete": " RFQ Completado",
            "Fully Received": " Totalmente recibido",
            "Partial Received": " Parcial recibido",
            "Default Ship To": "Enviar por defecto a",
            "Home store": "Tienda en casa",
            "Crib Identifier": " Identificador de cuna",
            "Enable Zeus": " Habilitar Zeus",
            "Disable Zeus": " Desactivar Zeus",
            "User information has been modified and saved successfully.": "La información del usuario se ha modificado y guardado correctamente.",
            "Error - password has already been used": "Error: ya se ha utilizado la contraseña",
            "User ID already exists": "El ID de usuario ya existe",
            "Invalid User ID": "ID de usuario no válido",
            "Technical issue": "Problema técnico",
            "Equipment": "Equipo",
            "WO#_History": "Historia de WO#",
            "Sub_category": "Subcategoría",
            "Filter records": "Filtro registros",
            "Please select any fields to view the equipments": "Por favor, seleccione cualquier campo para ver los equipos",
            "Please enter a WO# to continue": "Por favor, introduzca un WO# para continuar",
            "Adding an item will remove the current items in your shopping cart. Do you want to proceed with this change?": "Al agregar un artículo, se eliminarán los artículos actuales en su carrito de compras. ¿Desea continuar con este cambio?",
            "Confirmation": "Confirmación",
            "Item successfully added to cart": "Artículo agregado exitosamente al carro",
            "Punchout Catalog": "Catálogo acceso directo",
            "Enter Login Id": "Introduzca el ID de inicio de sesión",
            "Enter Email Address": "Introduzca la dirección de correo electrónico",
            "Enter Old Password": "Ingrese la contraseña anterior",
            "Enter New Password": "Introduzca la nueva contraseña",
            "Enter Confirm Password": "Ingrese la contraseña de confirmación",
            "Old Password is required": "Se requiere una contraseña antigua",
            "New Password is required": "Se requiere una nueva contraseña",
            "Confirm Password is required": "Confirmar que la contraseña es obligatoria",
            "Password doesn't match": "La contraseña no coincide",
            "Warning!\nYou do not have permission to access the application": "¡Advertencia!\nNo tiene permiso para acceder a la aplicación",
            "Please enter required fields": "Introduzca los campos obligatorios",
            "If the data provided is correct, you will receive an email with password reset instructions": "Si los datos proporcionados son correctos, recibirá un correo electrónico con instrucciones para restablecer la contraseña",
            "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character. Max length for password is 128 characters.": "La contraseña debe contener al menos diez caracteres con 1 número, 1 mayúscula, 1 minúscula y 1 carácter especial.La longitud máxima de la contraseña es de 128 caracteres.",
            "Please enter your zeus ID and password": "Introduzca un ID y una contraseña de Zeus",
            "Please enter zeus ID": "Por favor, introduzca el ID de Zeus",
            "Please enter a password": "Por favor, introduce una contraseña",
            "Speed to Execution": "Velocidad de ejecución",
            "Agility": "Agilidad",
            "One SDI": "Una SDI",
            "Operation Excellence": "Excelencia Operacional",
            "Courage": "Valor",
            "Invalid ID/password": "ID/contraseña no válidos",
            "Zeus ID": "Zeus ID",
            "Manufacturer part # ": "Pieza del fabricante # ",
            "Manufacturer Part #": "Pieza del fabricante # ",
            "Manufacturer name": "Nombre del fabricante",
            "Recommended supplier": "Proveedor recomendado",
            "Supplier part #": "Parte del proveedor #",
            "Supplier Part #": "Parte del proveedor #",
            "Quantity": "Cantidad",
            "Unit of measure": "Unidad de medida",
            "Please enter manufacturer part #": "Introduzca la pieza del fabricante #",
            "Please enter manufacturer name": "Introduzca el nombre del fabricante",
            "Please enter quantity": "Por favor, introduzca la cantidad",
            "Enter manufacturer part #": "Introduzca la pieza del fabricante #",
            "Enter manufacturer name": "Introduzca el nombre del fabricante",
            "Enter recommended supplier": "Introduzca el proveedor recomendado",
            "Enter supplier part #": "Introducir la parte del proveedor #",
            "Enter quantity": "Introduzca la cantidad",
            "Attachment ": "Archivo adjunto ",
            "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names.": "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names.",
            "Description": "Descripción",
            "Enter Description": "Introduzca la descripción",
            "Please enter description": "Por favor, introduzca la descripción",
            "Order information": "Información del pedido",
            "Work order #": "# de Orden de trabajo",
            "Enter work order #": "Enter work order #",
            " WO# History": "Historia de WO #",
            "Enter work order number": "Ingrese el número de orden de trabajo",
            "Please select Ship to ": "Por favor, seleccione Enviar a ",
            "Enter Valid Work Order #": "Ingrese una orden de trabajo válida #",
            "The default Ship-To's Country Code does not match the Work Order Store Country Code.": "The default Ship-To's Country Code does not match the Work Order Store Country Code.",
            "Order notes": "Notas de pedido",
            "Enter order notes": "Introducir notas de pedido",
            "Priority ": "prioridad ",
            "Item details": "Detalles del artículo",
            "Cancel order": "Cancelar pedido",
            "Submit Order": "Enviar pedido",
            "Order submitted for sourcing": "Pedido enviado para abastecimiento",
            "Successfully added to  cart": "Successfully added to  cart",
            "Technical Issue -- Contact SDI": "Problema técnico -- Póngase en contacto con SDI",
            "Insufficient privilege to view non-catalog request": "Privilegio insuficiente para ver solicitudes que no son de catálogo",
            "You can choose only the Image and PDF files!!": "Puede elegir solo los archivos de imagen y PDF!!",
            "Selected file is already attached, please try again": "Selected file is already attached, please try again",
            "Please use different work order # for this panel.": "Utilice una orden de trabajo # diferente para este panel.",
            "Is this priority?": "¿Es esta una prioridad",
            "Browse": "Hojear",
            "Please enter a valid Quantity": "Please enter a valid Quantity",
            "Invalid Item Number entered for Quick Item Entry": "Número de artículo no válido ingresado para la entrada rápida de artículos",
            " Upload": "subir",
            "Save": "Guardar",
            "Ship to": "Envie a",
            "Technical issue please contact SDI help desk": "Problema técnico: póngase en contacto con el servicio de asistencia de SDI",
            "Please select the Shipment Method": "Please select the Shipment Method",
            "Previously Purchased Items": "Artículos comprados anteriormente",
            "Suggestions": "Sugerencias",
            "Please enter work order number": "Please enter work order number",
            "Search results will be based on your selection": "Los resultados de la búsqueda se basarán en su selección",
            "Manage Forms": "Administrar formularios",
            "Ordering": "Ordenamiento",
            "Sourced Non-Catalog Entry": "Entrada de origen no catalogada",
            "Source non-catalog entry": "Entrada de origen no catalogada",
            "Procurement": "Procuración",
            "Email": "Correo electrónico",
            "Interactive Diagrams": "Diagramas interactivos",
            "Walk-In": "Recoger en tienda",
            "Reference Site Maintenance": "Mantenimiento del sitio de referencia",
            "FedEx Shipping": "Envío de FedEx",
            "Cycle Counting": "Conteo cíclico",
            "Field Inventory Workbench": "Field Inventory Workbench",
            "Release Notes Maintenance": "Liberar notas de Mantenimiento",
            "Fulfillment": "Cumplimiento",
            "Item Master": "Maestro de objetos",
            "Maintain Inventory": "Mantener el inventario",
            "SDIMS Online": "SDIMS en línea",
            "Print Container Bar Code Labels": "Imprimir etiquetas de código de barras para contenedores",
            "Stock Issue": "Emisión de acciones",
            "Return to Inventory": "Volver al inventario",
            "Picking Assign To": "Selección Asignar a",
            "Reprint Packing": "Reimpresion del empaque",
            "Default Putaway Location": "Ubicación de almacenamiento predeterminada",
            "Add Stock Items": "Añadir artículos en stock",
            "Bin-to - Bin Transfer": "Transferencia de contenedor a contenedor",
            "Manual Stock Adjustment": "Manual Stock",
            "Item Holds": "Reservas de objetos",
            "Material Storage Locations": "Emplacement d’entreposage des matériaux",
            "Express Putaway": "Almacenamiento exprés",
            "Mobile Inventory Management System": "Sistema móvil de gestión de inventario",
            "Load Stage and Putaway": "Etapa de carga y almacenamiento",
            "Shipments": "Envíos",
            "Expediting": "Acelerar",
            "Open POs": "POs abiertos",
            "Transaction Report": "Informe de transacciones",
            "SDI ASN Entry": "Entrada de ASN de SDI",
            "PO Workbench": "Banco de trabajo PO",
            "You searched for": "Has buscado",
            "Search Result": "Resultado de la búsqueda",
            "Enter WO#": "Ingresa # Orden de Trabajo",
            "selectWO": "Seleccione WO",
            "shipsBy": "Envíos por",
            "quantity": "Cantidad",
            "price": "Precio",
            "Matching part details": "Detalles de piezas a juego",
            "UOM": "UOM",
            "Warehouse": "Almacén",
            "Truck Stock": "Inventario en Camionieta",
            "Shipment Method": "Método de envío",
            "Equivalent Parts": "Partes equivalentes",
            "Supplier part number": "Número de pieza del proveedor",
            "MFG name": "Nombre de MFG",
            "MFG part number": "Número de pieza MFG",
            "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?": "Al agregar un artículo, se eliminarán los artículos de equipo en su carrito de compras. ¿Desea continuar con este cambio?",
            "Entered quantity is greater than the available quantity ": "La cantidad introducida es mayor que la cantidad disponible",
            "Quantity Entered Is Below The Minimum Order Quantity": "La cantidad introducida está por debajo de la cantidad mínima de pedido",
            "Entered Quantity Does Not Match the Minimum Order Quantity Sequence": "La cantidad introducida no coincide con la secuencia de cantidad mínima del pedido",
            " Item is already added in the cart ": "El artículo ya está agregado en el carrito",
            "KENSTAN-KEY is already added to cart, only one key allow for one cart. Please go to cart to increase quantity": "KENSTAN-KEY ya está agregado al carrito, solo una llave permite un carrito. Por favor, vaya al carrito para aumentar la cantidad",
            "This item is already in the cart and has reached the maximum number of 10 forms": "Este artículo ya está en el carrito y ha alcanzado el número máximo de 10 formularios",
            " is not added to cart due to technical issue. Contact SDI customer care.": "no se agrega al carrito debido a un problema técnico.Póngase en contacto con el servicio de atención al cliente de SDI.",
            "Item successfully added to cart and added item applies core charges": "El artículo agregado con éxito al carrito y el artículo agregado aplica cargos básicos",
            "Item cannot be added to cart due to technical issue.Contact SDI customer care.": "El artículo no se puede agregar al carrito debido a un problema técnico. Póngase en contacto con el servicio de atención al cliente de SDI",
            "Favorite item removed sucessfully": "Elemento favorito eliminado con éxito",
            "You cannot decrement Below the minimum order quantity": "No puede disminuir por debajo de la cantidad mínima de pedido",
            "Favorite item inserted successfully": "Elemento favorito insertado con éxito",
            "Quantity Cannot Be Zero": "La cantidad no puede ser cero",
            "Quantity Should Not Be Empty": "La cantidad no debe estar vacía",
            "This Kensktan lock is already in the cart. Please go to cart to increase quantity": "Este candado Kensktan ya está en el carrito. Por favor, vaya al carrito para aumentar la cantidad",
            "This Enersys Item is already added in the cart": "Este artículo de Enersys ya está añadido en el carrito",
            "This Door Item is already added in the cart. Please go to cart to increase quantity": "Este artículo de puerta ya está agregado en el carrito. Por favor, vaya al carrito para aumentar la cantidad",
            "Technical Issue Try again": "Problema técnico, inténtelo de nuevo",
            "Long description": "Descripción larga",
            "Short description": "Breve descripción",
            "Rating": "Clasificación",
            "Supplier": "Proveedor",
            "Minimum Order Quantity": "Cantidad mínima de pedido",
            "Delivers By": "Entrega por",
            "Total Order Quantity": "Cantidad total del pedido",
            "Things to be noted while uploading an Image": "Cosas que se deben tener en cuenta al cargar una imagen",
            "1.Size should be large": "1.El tamaño debe ser grande",
            "2.Background must be black/white": "2.El fondo debe ser blanco o negro",
            "3.Should not contains any watermarks": "3.No debe contener marcas de agua",
            "4.Should contains only one part per image": "4.Debe contener solo una parte por imagen",
            "5.Should not be a hand held picture": "5.No debe ser una imagen de mano",
            "User also bought": "El usuario también compró",
            "No records found": "No se encontraron registros",
            "Add Review": "Agregar reseña",
            "Inventory": "Inventario",
            "Attributes": "Atributos",
            "Also Fits": "También se adapta",
            "Links": "Enlaces",
            "Image Uploaded Successfully!": "Imagen cargada con éxito!",
            "Upload failed!": "Error de carga!",
            "Confirmation": "Confirmación",
            "No reviews yet": "No hay valoraciones aún",
            "Replacement batteries are not currently available through Zeus, please consult with your manager or vendor management office (VMO) or order a replacement through service channel via home office realty procurement solutions (RPS) - sorry for any inconvenience this may cause": "Las baterías de repuesto no están disponibles actualmente a través de Zeus, consulte con su gerente u oficina de gestión de proveedores (VMO) o solicite un reemplazo a través de Service Channel por medio de Home Office Realty Procurement Solutions (RPS) - disculpe cualquier inconveniente que esto pueda causar",
            "Package Quantity": "Cantidad del paquete",
            "Updated to Walmart Preferred Item(s)": "Actualizado a Artículo(s) preferido(s) de Walmart",
            "Ship within": "Enviar dentro de",
            "Add To Cart": "Añadir a la cesta",
            "Thank you for your response": "¡Gracias por su respuesta",
            "Error in inserting the rating. Please contact SDI": "Error al insertar la calificación. Por favor, póngase en contacto con SDI",
            "Punchout Catalog": "Catálogo acceso directo",
            "Field name in English": "Field name in Spanish",
            "PO Workbench": "Banco de trabajo PO",
            "Select or enter at least one of the following ( ) fields: Ship to locationC-O-M-M-A PO numberC-O-M-M-A Vendor nameC-O-M-M-A Install store and Work order to filter down your records": "Seleccione o ingrese al menos uno de los siguientes campos ( ): Enviar a ubicaciónC-O-M-M-A Número de orden de compraC-O-M-M-A Nombre del proveedorC-O-M-M-A Instalar tienda y Orden de trabajo para filtrar sus registros",
            "Enter ship to location": "Ingrese el envío a la ubicación",
            "Enter PO number": "Introduzca el número de orden de compra",
            "Install store": "Instalar tienda",
            "WO status": "Estado de la OT",
            "Tech name": "Nombre técnico",
            "Problem codes": "Códigos de problema",
            "Install customer": "Instalar cliente",
            "WO priority": "Prioridad de OT",
            "PO due date": "Fecha de vencimiento de la orden de compra",
            "MFG part #": "Pieza MFG #",
            "MFG ID": "ID de MFG",
            "Open qty": "Cantidad abierta",
            "ASN qty": "Cantidad de ASN",
            "Invoiced qty": "Cantidad facturada",
            "Unit price ($)": "Precio unitario ($)",
            "REQ ID": "ID DE SOLICITUD",
            "Freight provider": "Proveedor de carga",
            "Enter tracking no": "Introduzca el número de seguimiento",
            "ASN ship date": "Fecha de envío del ASN",
            "Problem code": "Código del problema",
            "Expedite comments": "Agilizar los comentarios",
            "Add attachments": "Agregar archivo adjunto",
            "View": "Vista",
            "Cancel item": "Cancelar artículo",
            "Files": "Archivos",
            "File name exceeds limit.Please shorten or remove teh files": "El nombre del archivo supera el límite. Por favorC-O-M-M-A acorte o elimine los archivos",
            "Selected file is already attached. Please upload another file": "El archivo seleccionado ya está adjunto. Por favorC-O-M-M-A cargue otro archivo",
            "You can choose only the Image (jpgC-O-M-M-A jpegC-O-M-M-A \r\npng) and PDF files": "\"Puedes elegir solo la imagen (jpgC-O-M-M-A jpegC-O-M-M-A\r\npng) y archivos PDF\"",
            "OK": "OK",
            "Vendor detail": "Detalle del proveedor",
            "Vendor loc": "Ubicación del proveedor",
            "Contact": "Contacto",
            "Entered by": "Ingresado por",
            "Your item has been cancelled successfully": "Tu artículo ha sido cancelado con éxito",
            "Error occurred while updating": "Se ha producido un error al actualizar",
            "PO line details updated successfully": "Los detalles de la línea de orden de compra se actualizaron con éxito",
            "Must include T at start and ( ) as the 12th character": "Debe incluir T al principio y ( ) como el 12º carácter",
            "Must include 1 at start and (Z) as the 2nd character": "Debe incluir 1 al principio y (Z) como 2º carácter",
            "Not a valid FEDEX tracking number": "No es un número de seguimiento de FEDEX válido",
            "Not a valid UPS tracking number.": "No es un número de seguimiento de UPS válido.",
            "Error in inserting the rating. Please contact SDI": "Error al insertar la calificación. Por favor, póngase en contacto con SDI",
            "Supplier call-in": "Llamada de proveedor",
            "Search Panel": "Panel de búsqueda",
            "Please enter a WO# to continue": "Por favor, introduzca un # de Orden de Trabajo para continuar",
            "Manufacturer part number is required to check the catalog": "Se requiere el número de pieza del fabricante para consultar el catálogo",
            "Qty ": "Cantidad",
            "Proceed": "PROCEDER",
            "No attributes available": "No hay atributos disponibles",
            "Owner": "dueña",
            "Qty On Hand": "Cantidad en stock",
            "Total Qty Reserved/Not Shipped": "Cantidad total reservada/no enviada",
            "Defect Loc": "Defecto Loc",
            "Qty Available": "Cantidad disponible",
            "Defect Loc": "Defecto Loc",
            "Qty Bin": "Cantidad Contenedor",
            "Qty Reserved/Not Picked": "Cantidad reservada/no recogida",
            "Pack Qty": "Cantidad por paquete",
            "Area": "Área",
            "Aisle": "Pasillo",
            "Row": "Fila",
            "Shelf": "Estante",
            "Bin": "Bote",
            "Please rate this item": "Por favor, califique este artículo",
            "Write a review": "Escribe una reseña",
            "Item Details": "Detalles del artículo",
            "Alternate Parts": "Partes alternativas",
            "Item": "Artículo",
            "This": "Esto",
            "More": "más",
            "Less": "menos",
            "Are you sure you want to reset your password?": "¿Estás seguro de que quieres restablecer tu contraseña?",
            "Are you sure you want to cancel the order?": "¿Estás seguro de que quieres cancelar el pedido?",
            "Catalog Description": "Descripcion de catalogo",
            "Client Description": "Descripcion del cliente",
            "Receiving Report": "Reporte de Recepción",
            "My Profile": "Mi Perfil",
            "Incidents": "Incidentes",
            "Incident": "Incidentes",
            "Container Packing": "Empaque de contenedor",
            "Container packing": "Empaque de contenedor",
            "Refresh": "Actualizar",
            "Links are for reference information only.\nDo not place orders from suppliers site.": "Los enlaces son solo para información de referencia.\nNo realice pedidos desde el sitio de los proveedores",
            "All Categories": "Todas las categorías",
            "Min Order Quantity": "Cantidad Min de Pedido",
            "My favorite item": "Mi artículo favorito",
            "My favorite order": "Mi pedido favorito",
            "Supplier Suggestion": "Sugerencia del proveedor",
            "Search for product": "Buscar producto",
            "You can choose only the Image files!!": "Puede elegir solo los archivos de imagen",
            "The Item you have chosen has a CORE RETURN REQUIREMENT, a CORE Charge fee will be charged at time of purchase and refunded upon return of the associated CORE to the supplier.": "El artículo que ha elegido tiene un REQUISITO DE DEVOLUCIÓN PRINCIPAL, se cobrará una tarifa de cargo CORE en el momento de la compra y se reembolsará al devolver el CORE asociado al proveedor.",
            "By choosing to PROCEED, You acknowledge that you will ensure the CORE is returned as required!": "Al elegir CONTINUAR, usted reconoce que se asegurará de que el CORE se devuelva según sea necesario.",
            "Added to favorite pages": "Añadido a páginas favoritas",
            "Removed from favorite pages": "Eliminado de las páginas favoritas",
            "Showing results for your image": "Mostrando resultados para tu imagen",
            "Choose File": "Elegir archivo",
            "Tracking Number Update": "Actualización del número de seguimiento",
            "Favorite item inserted sucessfully": "Elemento favorito insertado con éxito",
            "Please provide the reason for selecting this supplier": "Por favor, proporcione la razón por la que seleccionó a este proveedor",
            "Add to favorite item": "Añadir a un artículo favorito",
            "Item Image Detail": "Detalle de la imagen del artículo",
            "Qty Reserved/Not Picked": "Cantidad reservada/no recogida",
            "Choose Your Own image": "Elige tu propia imagen",
            "Enter Sub Category": "Ingresa la subcategoria",
            "A maximum of 10 forms can be included per item.": "Se puede incluir un máximo de 10 formularios por artículo.",
            "Quantity filled": "Cantidad llenada",
            "Please fill all the mandatory fields": "Por favor, llene todos los campos obligatorios",
            "The entered quantity does not match the requested quantity": "La cantidad introducida no coincide con la cantidad solicitada",
            "The maximum number of forms has been reached. Please adjust the quantity or place a separate order.": "Se ha alcanzado el número máximo de formularios. Ajuste la cantidad o haga un pedido por separado.",
            "No file is selected": "No se ha seleccionado ningún archivo",
            "MFG": "Fabricación",
            "MFG part": "Pieza de fabricación",
            "Sent for Sourcing": "Enviado para abastecimiento",
            "Search suggestion": "Sugerencia de búsqueda",
            "Sub Category": "Sub categoría",
            "Enter category": "Entrar en la categoría",
            "Do you want to add Image for this item?": "¿Desea agregar una imagen para este artículo?",
            "Comments": "Comentarios",
            "Enter comments": "Introducir comentarios",
            "Reason type": "Tipo de motivo",
            "--Select Ship To--": "Seleccione enviar a",
            "Order Approval": "Aprobación de pedidos",
            "or": "o",
            "Your account is inactive. Please contact the help desk at ***-***-*** to reinstate your account.": "Tu cuenta está inactiva. Póngase en contacto con el servicio de asistencia en ***-***-*** para restablecer su cuenta.",
            "Your account has been disabled due to excessive invalid login attempts.Please contact the help desk at": "Su cuenta ha sido desactivada debido a un exceso de intentos de inicio de sesión no válidos. Póngase en contacto con el servicio de asistencia en",
            "Your account has been inactivated please contact the help desk at": "Su cuenta ha sido inactivada, por favor póngase en contacto con el servicio de asistencia al",
            "to reinstate your account.": "para restablecer su cuenta.",
            "Invalid ID/password": "ID/contraseña no válidos",
            "Apply": "Aplicar"
        }
    }
};

i18n

    .use(initReactI18next)
    .init({

        resources,
        fallbackLng: CookieService.getLocalStorageValues("newlanguage") ? CookieService.getLocalStorageValues("newlanguage").value : 'en',

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    })

export default i18n;





